/* eslint-disable no-undef */
// App.js - 中国站版本
// 直接替换你现有App.js文件的开头部分（从开头到第一个useCallback之前）
import About from './About';
import Contact from './Contact';
import FAQ from './FAQ';
import PrivacyPolicy from './PrivacyPolicy';
import './App.css';
import PersonalCenter from './PersonalCenter';
import React, { useState, useEffect, useRef, useCallback, useMemo, Suspense } from 'react';
import { authAPI, setAuthToken, getAuthToken, sentencesAPI } from './api';
import API_BASE_URL from './config';
import WordPlayer from './WordPlayer';
import './WordPlayer.css';
import QRCodeFloatButton from './QRCodeFloatButton';
import ProgressBars from './ProgressBars';
import HeaderTitleSection from './HeaderTitleSection';
import HeaderUserSection from './HeaderUserSection';
import ModeSwitchButtons from './ModeSwitchButtons';
import LoginModal from './LoginModal';

// 挂载时触发回调的辅助组件
function FireworksOnMount({ onMount }) {
  useEffect(() => {
    onMount();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

function App() {
  // === 优化后的状态管理 ===
  const [isHovering, setIsHovering] = useState(false); //logo旋转
  const [greenScreen, setGreenScreen] = useState(false); // 绿屏模式
  const [showQRCode, setShowQRCode] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loginTab, setLoginTab] = useState('login'); // 'login' | 'register' | 'reset' | 'wechat'
  const [showFireworks, setShowFireworks] = useState(false);
  const [wordSplitAnim, setWordSplitAnim] = useState(false);
  const [splitWord, setSplitWord] = useState('');
  const wordRef = useRef(null);
  const [wordRect, setWordRect] = useState(null);
  // 广告弹窗状态
  const [showAdModal, setShowAdModal] = useState(false);
  const [adImages, setAdImages] = useState([]);
  const [currentAdImage, setCurrentAdImage] = useState('');
  const adImagesRef = useRef([]);
  const adModeRef = useRef('random');
  const adFixedFileRef = useRef('');
  // 自动播放单词弹窗
  const [showWordPlayer, setShowWordPlayer] = useState(false);
  const adTimerRef = useRef(null);
  
  

  // 基础数据状态
  const [words, setWords] = useState([]);
  const [filteredWords, setFilteredWords] = useState([]);
  const [error, setError] = useState(null);
  const [authError, setAuthError] = useState(null);
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [inputValue, setInputValue] = useState('');
  const [dailyProgress, setDailyProgress] = useState({});
  const [category, setCategory] = useState(() => {
    // 从 localStorage 读取上次的级别，如果没有则默认为 'elementary'
    const savedCategory = localStorage.getItem('lastCategory');
    return savedCategory || 'elementary';
  });
  const [studyMode, setStudyMode] = useState('word'); // 'word' | 'usage' | 'sentence'
  const [sentenceSources, setSentenceSources] = useState([]);
  const [currentSource, setCurrentSource] = useState('');
  const [sentences, setSentences] = useState([]);
  const [isSentencesLoading, setIsSentencesLoading] = useState(true); // 用于区分“还在加载中”和“真的全部削完了”
  const [currentSentenceIndex, setCurrentSentenceIndex] = useState(0);
  const [masteredSentences, setMasteredSentences] = useState({});
  const [sentenceInput, setSentenceInput] = useState('');
  const [isSentenceInputError, setIsSentenceInputError] = useState(false);
  const [isSentenceCorrect, setIsSentenceCorrect] = useState(false);
  const [isInSentenceMasterMode, setIsInSentenceMasterMode] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [sentenceAudioType, setSentenceAudioType] = useState('us'); // 'us' | 'uk' | 'cn'

  // 根据美式/英式/中文取出句子对应的音频字段
  const getSentenceAudioPath = (sentence, type) => {
    if (!sentence) return null;
    if (type === 'cn') return sentence.audio_cn;
    if (type === 'uk') return sentence.audio_uk;
    return sentence.audio_us;
  };
  // 相对路径补全域名（服务器返回的是相对路径）
  const resolveAudioFullUrl = (url) => {
    if (!url) return null;
    return url.startsWith('http') ? url : `https://www.xiaocixia.cn${url}`;
  };

  // eslint-disable-next-line no-unused-vars
  const [sentenceLoop, setSentenceLoop] = useState(false);
  const sentenceLoopAudioRef = useRef(null);
  const [sentenceSearchQuery, setSentenceSearchQuery] = useState('');
  const [sentenceSearchResults, setSentenceSearchResults] = useState([]);
  const [currentSentenceSearchIndex, setCurrentSentenceSearchIndex] = useState(0);
  const [autoPlayAudio, setAutoPlayAudio] = useState(false);
  const [exampleSpeedMultiplier, setExampleSpeedMultiplier] = useState(() => {
    const saved = localStorage.getItem('exampleSpeedMultiplier');
    return saved ? parseFloat(saved) : 1;
  });
  const [pronunciationType, setPronunciationType] = useState('us'); // 默认美式发音
  const [showExampleAfterCorrect, setShowExampleAfterCorrect] = useState(false);
  const [isExamplePaused, setIsExamplePaused] = useState(false);
  const [isExampleLooping, setIsExampleLooping] = useState(false);
  const isExampleLoopingRef = useRef(false);
  const [searchExampleLoopType, setSearchExampleLoopType] = useState(null); // null | 'us' | 'uk'
  const searchExampleAudioRef = useRef(null);
  const searchExampleAudioRef2 = useRef(null); 
  const exampleAudioRef = useRef(null);
  const exampleTimerRef = useRef(null);
  const exampleResolveRef = useRef(null);

  // 播放例句音频
  const playExampleAudio = useCallback((audioPath, onEnded) => {
    if (exampleAudioRef.current) {
      exampleAudioRef.current.pause();
      exampleAudioRef.current = null;
    }
    if (!audioPath) return null;
    
    const audio = new Audio(audioPath);
    audio.onended = () => {
      if (isExampleLoopingRef.current) {
        audio.currentTime = 0;
        audio.play().catch(e => console.log('循环播放失败:', e));
      } else if (onEnded) {
        onEnded();
      }
    };
    audio.play().catch(e => console.log('例句音频播放失败:', e));
    exampleAudioRef.current = audio;
    return audio;
  }, []);

  // 例句展示倒计时（可被暂停打断）
  const finishExample = useCallback(() => {
    setShowExampleAfterCorrect(false);
    setIsExamplePaused(false);
    setIsExampleLooping(false);
    isExampleLoopingRef.current = false;
    if (exampleAudioRef.current) {
      exampleAudioRef.current.pause();
      exampleAudioRef.current = null;
    }
    if (exampleTimerRef.current) {
      clearTimeout(exampleTimerRef.current);
      exampleTimerRef.current = null;
    }
    setTimeout(() => {
      if (inputRef.current) inputRef.current.focus();
    }, 50);
    if (exampleResolveRef.current) {
      exampleResolveRef.current();
      exampleResolveRef.current = null;
    }
  }, []);

  const startExampleTimer = useCallback((duration) => {
    if (exampleTimerRef.current) {
      clearTimeout(exampleTimerRef.current);
    }
    exampleTimerRef.current = setTimeout(finishExample, duration);
  }, [finishExample]);

  // 点击例句区域：暂停/继续
  const toggleExamplePause = useCallback(() => {
    if (isExamplePaused) {
      // 继续：再给2秒缓冲后自动消失（用户点了继续，说明看完了，给个短暂时间后跳走）
      setIsExamplePaused(false);
      startExampleTimer(2000);
    } else {
      // 暂停：停止倒计时，音频也暂停
      if (exampleTimerRef.current) {
        clearTimeout(exampleTimerRef.current);
      }
      if (exampleAudioRef.current) {
        exampleAudioRef.current.pause();
      }
      setIsExamplePaused(true);
    }
  }, [isExamplePaused, startExampleTimer]);

  // 重播例句音频（单次）
  const replayExampleAudio = useCallback((currentWordData) => {
    if (!currentWordData) return;
    const audioPath = pronunciationType === 'uk' 
      ? (currentWordData.example_audio_uk || currentWordData.example_audio_us)
      : (currentWordData.example_audio_us || currentWordData.example_audio_uk);
    isExampleLoopingRef.current = false;
    setIsExampleLooping(false);
    playExampleAudio(audioPath, null);
  }, [pronunciationType, playExampleAudio]);

  // 切换循环播放例句
  const toggleExampleLoop = useCallback((currentWordData) => {
    const newLooping = !isExampleLoopingRef.current;
    isExampleLoopingRef.current = newLooping;
    setIsExampleLooping(newLooping);
    if (newLooping && currentWordData) {
      const audioPath = pronunciationType === 'uk' 
        ? (currentWordData.example_audio_uk || currentWordData.example_audio_us)
        : (currentWordData.example_audio_us || currentWordData.example_audio_uk);
      playExampleAudio(audioPath, null);
    }
  }, [pronunciationType, playExampleAudio]);
  
  const [currentPage, setCurrentPage] = useState('learning');
  const [isLoadingUser, setIsLoadingUser] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  // 学句子 搜索结果 循环播放
  const [loopingAudio, setLoopingAudio] = useState(null); // 'us' | 'uk' | null
  const [loopAudioRef, setLoopAudioRef] = useState(null);
  
  // 用户相关状态
  const [user, setUser] = useState(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [userProfile, setUserProfile] = useState({
    displayName: '',
    photoURL: '',
  });
  const [completedCounts, setCompletedCounts] = useState({});

  // 处理微信回调
  const [showWxBindModal, setShowWxBindModal] = useState(false);
  const [wxTempToken, setWxTempToken] = useState('');
  const [wxBindEmail, setWxBindEmail] = useState('');
  const [wxBindPassword, setWxBindPassword] = useState('');
  const [wxBindError, setWxBindError] = useState('');
  
  // 功能设置状态
  const [keyboardSound, setKeyboardSound] = useState(false);
  const [autoPlay, setAutoPlay] = useState(true);
  const [loopPlay, setLoopPlay] = useState(false);
  const [interaction, setInteraction] = useState(false);
  
  // 搜索相关状态
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  // ✅ 新增：会话级别的已学习单词列表
  const [sessionLearnedWords, setSessionLearnedWords] = useState(() => {
    // 从 localStorage 读取当前会话已学习的单词
    const saved = localStorage.getItem(`session_learned_${category}`);
    return saved ? JSON.parse(saved) : [];
  });
  
  // === 合并的UI状态（优化：减少useState数量）===
  const [uiState, setUiState] = useState({
    isWordInputFocused: false,
    showLoading: false,
    isInputIncorrect: false,
    isMasterLoading: false,
    isIncorrectWord: false,
    searchMode: false,
    // 新增削词相关状态
    isInMasterMode: false,        // 是否处于削词模式（单词已隐藏）
    masterModeWord: '',           // 削词模式下的目标单词
    masterModeFailedWords: {},    // 削词失败的单词记录 {word: true}
  });

  // === 合并的掌握单词状态（优化：统一管理）===
  const [masteredState, setMasteredState] = useState({
    mastered: {},
    manual: {},
    learned: {},
  });

  // 👇 新增：响应式状态
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // 主题状态（带localStorage持久化）
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved || 'light';
  });

  // Refs
  const inputTimerRef = useRef(null);
  const inputRef = useRef(null);
  const emailInputRef = useRef(null);
  const passwordInputRef = useRef(null);
  const audioRef = useRef(null);
  const loopPlayTimeoutRef = useRef(null); // 音标循环播放的延迟播放定时器，用于在切换模式/退出搜索时取消
  const blurTimeoutRef = useRef(null);
  const lastBlurTimeRef = useRef(0);
  const isCompletingRef = useRef(false);

  // === 优化的计算和辅助函数 ===
  
  // 优化：使用useMemo避免重复创建数组
  const [categoryCounts, setCategoryCounts] = useState({});

  // 统计在线人数
  const [sessionId] = useState(() => {
    let sid = localStorage.getItem('sessionId');
    if (!sid) {
      sid = 'session_' + Date.now() + '_' + Math.random().toString(36).substring(2, 10);
      localStorage.setItem('sessionId', sid);
    }
    return sid;
  });

  // 隐藏测试入口：URL参数触发
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('mode') === 'sentence') {
      setStudyMode('sentence');
    }
  }, []);

  // 心跳：统计在线人数
  useEffect(() => {
    const sendHeartbeat = () => {
      fetch(`${API_BASE_URL}/api/words/heartbeat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId }),
      }).catch(() => {});
    };

    sendHeartbeat(); // 立即发送一次
    const timer = setInterval(sendHeartbeat, 20000); // 每20秒发送一次

    return () => clearInterval(timer);
  }, [sessionId]);

  // 从API实时获取各级别单词数
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/words/counts`)
      .then(res => res.json())
      .then(data => {
        if (data.counts) setCategoryCounts(data.counts);
      })
      .catch(err => console.warn('获取级别单词数失败:', err));
  }, []);

  const categories = useMemo(() => {
    return [
      { value: 'elementary', label: `小学 (${categoryCounts.elementary || 0} 词)` },
      { value: 'junior', label: `初中 (${categoryCounts.junior || 0} 词)` },
      { value: 'highschool', label: `高中 (${categoryCounts.highschool || 0} 词)` },
      { value: 'cet4', label: `四级 (${categoryCounts.cet4 || 0} 词)` },
      { value: 'cet6', label: `六级 (${categoryCounts.cet6 || 0} 词)` },
      { value: 'toefl', label: `考研/托福 (${categoryCounts.toefl || 0} 词)` },
      { value: 'ielts_gre', label: `雅思/GRE (${categoryCounts.ielts_gre || 0} 词)` },
    ];
  }, [categoryCounts]);

  // 优化：使用useMemo计算当前单词，避免重复计算
  const currentWord = useMemo(() => {
    if (uiState.searchMode) {
      return searchResults[currentWordIndex] || {};
    }
    return filteredWords[currentWordIndex] || {};
  }, [uiState.searchMode, searchResults, filteredWords, currentWordIndex]);

  // 优化：状态更新辅助函数，减少重复代码
  const updateUiState = useCallback((updates) => {
    setUiState(prev => ({ ...prev, ...updates }));
  }, []);

  const updateMasteredState = useCallback((updates) => {
    setMasteredState(prev => ({ ...prev, ...updates }));
  }, []);

  // App.js - 第2部分：进度统计和搜索功能
  // === 乱序函数（Fisher-Yates洗牌算法）===
  const shuffleArray = useCallback((array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }, []);

  // 主题切换函数
  const toggleTheme = useCallback(() => {
    setTheme(prev => {
      const newTheme = prev === 'light' ? 'dark' : 'light';
      localStorage.setItem('theme', newTheme);
      return newTheme;
    });
  }, []);

  // === 优化的进度统计计算 ===
  const progressStats = useMemo(() => {
    const totalWords = words.filter((w) => {
      if (Array.isArray(w.category)) {
        return w.category.some(cat => 
          String(cat).toLowerCase().trim() === category.toLowerCase().trim()
        );
      }
      return String(w.category || '').toLowerCase().trim() === category.toLowerCase().trim();
    }).length;
    
    const remainingWords = filteredWords.length;
    const totalCumulativeMastered = Object.keys(masteredState.manual).length;
    // currentCycleTotalWords不能小于filteredWords数量
    // currentCycleTotalWords应该不小于filteredWords数量
    const rawCycleTotalWords = Math.max(totalWords - totalCumulativeMastered, 0);
    const currentCycleTotalWords = filteredWords.length > rawCycleTotalWords 
      ? filteredWords.length 
      : rawCycleTotalWords;
    
    // ✅✅✅ 关键修改：使用剩余单词数计算已学习数量 ✅✅✅
    const studiedThisCycle = Math.max(currentCycleTotalWords - remainingWords, 0);
    
    const currentCycleProgress = currentCycleTotalWords > 0 
      ? Math.round((studiedThisCycle / currentCycleTotalWords) * 100) 
      : 0;
    
    const manualMasteredCount = Object.keys(masteredState.manual).length;
    const totalMasteredForProgress = Math.min(manualMasteredCount, totalWords);
    const masteredProgress = Math.round((totalMasteredForProgress / (totalWords || 1)) * 100);

    console.log('进度统计:', {
      totalWords,
      currentCycleTotalWords,
      remainingWords,
      studiedThisCycle,
      currentCycleProgress,
      totalCumulativeMastered,
    });

    return {
      totalWords,
      remainingWords,
      currentCycleTotalWords,
      studiedThisCycle,
      currentCycleProgress,
      manualMasteredCount,
      totalMasteredForProgress,
      masteredProgress,
    };
  }, [words, category, filteredWords, masteredState.manual]);  // ✅ 移除 sessionLearnedWords 依赖

  // 统一停止学单词/学用法页面下，所有可能仍在循环播放的音频（发音循环、例句循环、音标循环）
  const stopWordAudioLoops = useCallback(() => {
    if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; }
    setLoopingAudio(null);
    setLoopAudioRef(null);
    if (searchExampleAudioRef.current) {
      searchExampleAudioRef.current.pause();
      searchExampleAudioRef.current.onended = null;
      searchExampleAudioRef.current = null;
    }
    if (searchExampleAudioRef2.current) { searchExampleAudioRef2.current.pause(); searchExampleAudioRef2.current = null; }
    setSearchExampleLoopType(null);
    // 修复：取消尚未触发的延迟循环播放定时器，防止切换模式后音频“延迟才响”
    if (loopPlayTimeoutRef.current) {
      clearTimeout(loopPlayTimeoutRef.current);
      loopPlayTimeoutRef.current = null;
    }
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.src = '';
      audioRef.current = null;
    }
    setLoopPlay(false);
  }, [loopAudioRef]);

  // === 优化的搜索功能 ===
  const handleSearch = useCallback(async (query) => {
    setSearchQuery(query);
    
    if (!query.trim()) {
      stopWordAudioLoops();
      updateUiState({ searchMode: false });
      setSearchResults([]);
      setCurrentWordIndex(0);
      return;
    }

    updateUiState({ searchMode: true });

    try {
      // 直接调用后端搜索API，搜索全部单词库
      const response = await fetch(`${API_BASE_URL}/api/words/search?q=${encodeURIComponent(query.trim())}`);
      if (response.ok) {
        const data = await response.json();
        setSearchResults(data.words || []);
        setCurrentWordIndex(0);
        console.log(`搜索"${query}"，找到 ${data.words?.length || 0} 个结果`);
      } else {
        throw new Error('搜索API失败');
      }
    } catch (err) {
      console.warn('API搜索失败，降级到本地搜索:', err.message);
      // 降级：本地搜索
      const q = query.toLowerCase().trim();
      const results = words
        .filter(word =>
          word.word.toLowerCase().includes(q) ||
          (word.meaning_cn && word.meaning_cn.includes(q))
        )
        .map(word => {
          const w = word.word.toLowerCase();
          let priority;
          if (w === q) priority = 0;
          else if (w.startsWith(q)) priority = 1;
          else if (w.includes(q)) priority = 2;
          else priority = 3;
          return { ...word, _priority: priority };
        })
        .sort((a, b) => {
          if (a._priority !== b._priority) return a._priority - b._priority;
          return a.word.length - b.word.length;
        })
        .slice(0, 100)
        .map(({ _priority, ...word }) => word);
      setSearchResults(results);
      setCurrentWordIndex(0);
    }
  }, [words, updateUiState, stopWordAudioLoops]);

  const exitSearchMode = useCallback(() => {
    stopWordAudioLoops();
    updateUiState({ searchMode: false });
    setSearchQuery('');
    setSearchResults([]);
  }, [updateUiState, stopWordAudioLoops]);

  // === 优化的音频播放函数 ===
  const playAudio = useCallback(
    (audioPath, word, isLoop = false) => {
      if (!audioPath || audioPath === '') {
        console.log(`无音频: ${word}`);
        return;
      }
      console.log(`播放音频: ${audioPath}, 循环: ${isLoop}`);

      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = '';
        audioRef.current = null;
      }

      audioRef.current = new Audio(audioPath);
      audioRef.current.loop = isLoop;

      const playPromise = audioRef.current.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            console.log(`成功播放音频: ${word}, 循环: ${isLoop}`);
            setError(null);
          })
          .catch((err) => {
            console.error(`无法播放音频 ${word}: ${err.message}`);
          });
      }

      if (!isLoop) {
        audioRef.current.addEventListener(
          'ended',
          () => {
            if (audioRef.current) {
              audioRef.current.src = '';
              audioRef.current = null;
              console.log(`音频播放结束，清理 audioRef: ${word}`);
            }
          },
          { once: true }
        );
      }
    },
    []
  );

  const toggleLoopPlay = () => {
  setLoopPlay((prev) => {
    const newLoopPlay = !prev;
    if (loopPlayTimeoutRef.current) {
      clearTimeout(loopPlayTimeoutRef.current);
      loopPlayTimeoutRef.current = null;
    }
    if (prev && audioRef.current) {
      audioRef.current.pause();
      audioRef.current.src = '';
      audioRef.current = null;
      console.log('停止循环播放，清理 audioRef');
    } else if (!prev && currentWord.audio?.[pronunciationType] && currentWord.audio[pronunciationType] !== '') {
      loopPlayTimeoutRef.current = setTimeout(() => {
        loopPlayTimeoutRef.current = null;
        playAudio(currentWord.audio[pronunciationType], currentWord.word, true);
      }, 100);
    }
    console.log(`循环播放: ${newLoopPlay}`);
    return newLoopPlay;
  });
};

  // === 优化的进度保存功能 ===
  const saveAllProgress = useCallback(
    async (targetCategory) => {
      if (!user) {
        console.log('未登录，跳过保存');
        return true;
      }

      // 🔥 即使 dailyProgress 为空，也要保存 inputWords 等信息
      try {
        console.log(`批量保存用户 ${user.uid} 的所有进度, 级别: ${targetCategory}`);
        
        // 🔥 计算需要保存的关键数据
        // 确保保存的inputWords不超过实际单词数
        const inputWords = filteredWords.length;
        console.log(`💾 保存inputWords=${inputWords}`);  // 当前剩余的单词数量
        const currentWordToStudy = 
          filteredWords.length > 0 && currentWordIndex < filteredWords.length
            ? filteredWords[currentWordIndex].word
            : null;

        console.log(`📍 保存状态: inputWords=${inputWords}, currentIndex=${currentWordIndex}, currentWord=${currentWordToStudy}`);
        
        const response = await fetch(`${API_BASE_URL}/api/progress/${targetCategory}`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${getAuthToken()}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            words: dailyProgress,
            sessionLearned: sessionLearnedWords,
            inputWords: inputWords,                    // ← 🔥 新增：保存当前学习的单词数量
            currentWordIndex: currentWordIndex,        // ← 🔥 新增：保存当前学习位置
            lastReviewedWord: currentWordToStudy       // ← 🔥 新增：保存当前学习的单词
          })
        });

        if (!response.ok) {
          throw new Error('批量保存失败');
        }

        console.log(`✅ 成功保存所有进度到 ${targetCategory}，包含 ${sessionLearnedWords.length} 个会话学习记录，inputWords=${inputWords}`);
        return true;
      } catch (err) {
        console.error(`保存所有进度失败:`, err);
        setError(`保存所有进度失败: ${err.message}`);
        return false;
      }
    },
    [user, dailyProgress, sessionLearnedWords, filteredWords, currentWordIndex]  // ← 🔥 添加依赖
  );

  // === 音效系统 ===
  const playSwordSound = useCallback((filename) => {
    try {
      const audio = new Audio(`/audio/sword/${filename}`);
      audio.volume = 0.6;
      audio.play().catch(e => console.log('音效播放失败:', e.message));
    } catch (err) {
      console.log('音效失败:', err.message);
    }
  }, []);

  const playKeySound = useCallback((key) => {
    // 退格键
    if (key === 'Backspace') {
      playSwordSound('running01.mp3');
      return;
    }
    // 空格键
    if (key === ' ') {
      playSwordSound('sword22.wav');
      return;
    }
    // 普通按键：随机从轻碰音效中选一个
    const lightSounds = ['sword02.wav','sword03.wav','sword04.wav','sword05.wav','sword11.wav','sword12.wav','sword14.wav','sword19.wav','sword23.wav','sword24.wav'];
    const randomSound = lightSounds[Math.floor(Math.random() * lightSounds.length)];
    playSwordSound(randomSound);
  }, [playSwordSound]);

  // 开启/关闭音效本身的提示音
  const playToggleSound = useCallback((isOn) => {
    if (isOn) {
      playSwordSound('sword01.wav');
    } else {
      playSwordSound('sword21.wav');
    }
  }, [playSwordSound]);

  // 输入错误音效
  const playErrorSound = useCallback(() => {
    const errorSounds = ['sword09.wav', 'sword10.wav'];
    playSwordSound(errorSounds[Math.floor(Math.random() * errorSounds.length)]);
  }, [playSwordSound]);

  // 单词正确音效
  const playCorrectSound = useCallback(() => {
    const correctSounds = ['sword08.wav', 'sword20.wav'];
    playSwordSound(correctSounds[Math.floor(Math.random() * correctSounds.length)]);
  }, [playSwordSound]);

  // 削词成功音效
  const playMasterSound = useCallback(() => {
    const masterSounds = ['sword06.wav','sword07.wav','sword13.wav','sword18.wav'];
    playSwordSound(masterSounds[Math.floor(Math.random() * masterSounds.length)]);
  }, [playSwordSound]);

  // === 优化的手动削词功能 ===
  const handleManualMaster = useCallback(
    (word) => {
      if (!user || !word) {
        setError('请先登录以使用削词功能');
        return;
      }

      // 检查是否是削词失败的单词
      if (uiState.masterModeFailedWords[word]) {
        setError('该单词削词失败，请继续学习');
        return;
      }

      // 进入削词模式：隐藏单词，等待用户输入
      updateUiState({ 
        isInMasterMode: true,
        masterModeWord: word 
      });
      setInputValue(''); // 清空输入框
      
      if (inputRef.current) {
        inputRef.current.focus();
      }

      if (keyboardSound) playSwordSound('open02.wav');
      console.log(`进入削词模式: ${word}`);
    },
    [user, uiState.masterModeFailedWords, updateUiState, keyboardSound, playSwordSound]
  );

  // 新增：实际执行削词的函数（已修复：真正记录到排行榜和个人中心！）
  const executeMasterWord = useCallback(
    async (word) => {
      if (!user || !word) return;

      updateUiState({ isMasterLoading: true });

      try {
        const now = new Date().getTime();

        // 第一步：保存到实时进度表
        await fetch(`${API_BASE_URL}/api/progress/${category}/word`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${getAuthToken()}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ word }),
        });

        // 第二步：写入排行榜和个人中心（cumulative_mastered 表）
        await fetch(`${API_BASE_URL}/api/progress/cumulative/${category}`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${getAuthToken()}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            word,
            mastered_type: 'manual',
          }),
        });

        console.log(`手动削词成功，已永久记录到排行榜和个人中心：${word}（${category}）`);

        // 🔥 第三步：立即更新前端状态（关键！）
        updateMasteredState({
          mastered: { ...masteredState.mastered, [word]: true },
          manual: { ...masteredState.manual, [word]: true },
          learned: masteredState.learned
        });

        // 更新 dailyProgress
        const updatedDailyProgress = {
          ...dailyProgress,
          [word]: {
            reviewCount: 7,
            lastReviewed: now,
            nextReview: now,
            mastered: true,
            manualMaster: true,
          },
        };
        setDailyProgress(updatedDailyProgress);

        // 🔥 第四步：从 filteredWords 中移除该单词
        const newFilteredWords = filteredWords.filter((w) => w.word !== word);
        const newIndex = Math.min(currentWordIndex, newFilteredWords.length - 1);
        
        setFilteredWords(newFilteredWords);
        setCurrentWordIndex(newIndex >= 0 ? newIndex : 0);
        setInputValue(''); // 清空输入框

        if (newFilteredWords.length > 0) {
          updateUiState({ 
            masterModeWord: newFilteredWords[newIndex]?.word,
            isMasterLoading: false 
          });
          console.log(`削词成功，继续削词模式，下一个单词: ${newFilteredWords[newIndex]?.word}`);
        } else {
          updateUiState({ 
            isInMasterMode: false,
            masterModeWord: '',
            isMasterLoading: false 
          });
          setError(`${category} 类别的单词已全部掌握！`);
        }

        if (keyboardSound) playMasterSound();

        console.log(`削词成功: ${word}`);
      } catch (error) {
        console.error('削词失败:', error);
        setError(`削词失败: ${error.message}`);
        updateUiState({ isMasterLoading: false });
      }
    },
    [
      user, 
      category, 
      dailyProgress, 
      filteredWords, 
      currentWordIndex, 
      masteredState,
      updateMasteredState, 
      updateUiState,
      keyboardSound,
      playMasterSound,
    ]
  );

  // === 切换功能 ===
  const toggleAutoPlay = () => {
    setAutoPlay((prev) => {
      const newAutoPlay = !prev;
      console.log(`自动播放: ${newAutoPlay}`);
      return newAutoPlay;
    });
  };

  const toggleKeyboardSound = () => {
    if (!user) {
      setLoginTab('login');
      setShowLoginModal(true);
      setAuthError('登录后即可使用音效功能 🎵');
      return;
    }
    setKeyboardSound((prev) => {
      const newKeyboardSound = !prev;
      playToggleSound(newKeyboardSound);
      console.log(`音效: ${newKeyboardSound}`);
      return newKeyboardSound;
    });
  };

  const loadUserProgress = useCallback(
    async (userId, targetCategory) => {
      try {
        console.log(`📥 加载用户 ${userId} 的 ${targetCategory} 进度`);
        
        // 1️⃣ 加载进度数据
        const response = await fetch(`${API_BASE_URL}/api/progress/${targetCategory}`, {
          headers: {
            'Authorization': `Bearer ${getAuthToken()}`
          }
        });

        if (!response.ok) {
          throw new Error('加载进度失败');
        }

        const data = await response.json();
        const progressData = data.words || {};

        console.log(`📦 从服务器加载的进度数据:`, progressData);

        const serverSessionLearned = data.sessionLearned || [];
        
        setSessionLearnedWords(serverSessionLearned);
        localStorage.setItem(
          `session_learned_${targetCategory}`, 
          JSON.stringify(serverSessionLearned)
        );
        console.log(`✅ 从服务器加载会话记录，共 ${serverSessionLearned.length} 个单词:`, serverSessionLearned);

        // 2️⃣ 🔥 加载累积掌握的单词列表
        const cumulativeResponse = await fetch(`${API_BASE_URL}/api/progress/cumulative/${targetCategory}`, {
          headers: {
            'Authorization': `Bearer ${getAuthToken()}`
          }
        });

        let manualMastered = {};
        let learnedMastered = {};

        if (cumulativeResponse.ok) {
          const cumulativeData = await cumulativeResponse.json();
          manualMastered = cumulativeData.manualMastered || {};
          learnedMastered = cumulativeData.learnedMastered || {};
          
          console.log(`📊 累积掌握数据:`, {
            手动削词: Object.keys(manualMastered).length,
            学习掌握: Object.keys(learnedMastered).length
          });
        } else {
          console.warn('加载累积掌握数据失败');
        }

        // 3️⃣ 直接从API获取该类别的最新单词（避免words状态时序问题）
        let allWordsInCategory = [];
        try {
          const wordsApiRes = await fetch(`${API_BASE_URL}/api/words/category/${targetCategory}`);
          if (wordsApiRes.ok) {
            const wordsApiData = await wordsApiRes.json();
            allWordsInCategory = wordsApiData.words || [];
            console.log(`📖 从API直接获取 ${targetCategory} 单词数: ${allWordsInCategory.length}`);
          } else {
            throw new Error('API获取单词失败');
          }
        } catch (e) {
          // 降级：从本地words状态过滤
          console.warn('API获取单词失败，降级使用本地words状态:', e.message);
          allWordsInCategory = words.filter((w) => {
            if (Array.isArray(w.category)) {
              return w.category.some(cat => 
                String(cat).toLowerCase().trim() === targetCategory.toLowerCase().trim()
              );
            }
            return String(w.category || '').toLowerCase().trim() === targetCategory.toLowerCase().trim();
          });
        }

        const totalWords = allWordsInCategory.length;
        const allMastered = { ...manualMastered, ...learnedMastered };
        const masteredCount = Object.keys(allMastered).length;

        console.log(`📚 类别 ${targetCategory} - 总单词数: ${totalWords}, 已掌握: ${masteredCount}`);

        // 4️⃣ 🔥🔥🔥 新增：检测异常数据并自动清理 🔥🔥🔥
        if (masteredCount > totalWords) {
          console.warn(`⚠️ 检测到数据异常：已掌握 ${masteredCount} 个，但总单词只有 ${totalWords} 个`);
          
          try {
            console.log(`🔧 开始自动清理 ${targetCategory} 的数据...`);
            
            const cleanupResponse = await fetch(`${API_BASE_URL}/api/progress/${targetCategory}/cleanup`, {
              method: 'DELETE',
              headers: {
                'Authorization': `Bearer ${getAuthToken()}`
              }
            });
            
            if (cleanupResponse.ok) {
              const result = await cleanupResponse.json();
              console.log(`✅ 自动清理完成:`, result);
              
              const invalidWordsList = result.invalidWordsList || [];
              setError(
                `检测到数据异常，已自动修复！\n` +
                `清除会话记录: ${result.removedSessionWords} 个\n` +
                `删除无效单词: ${result.removedInvalidWords} 个` +
                (invalidWordsList.length > 0 ? `\n无效单词: ${invalidWordsList.join(', ')}` : '')
              );
              
              // 🔥 关键：重新加载数据（递归调用，但只执行一次）
              console.log('🔄 重新加载用户进度...');
              await loadUserProgress(userId, targetCategory);
              return; // 重要：终止当前执行，使用重新加载的数据
            } else {
              const errorText = await cleanupResponse.text();
              console.error('❌ 自动清理失败:', errorText);
            }
          } catch (cleanupError) {
            console.error('❌ 自动清理异常:', cleanupError);
          }
        }

        // 5️⃣ 更新 masteredState
        updateMasteredState({
          mastered: allMastered,
          manual: manualMastered,
          learned: learnedMastered,
        });

        // 6️⃣ 🔥🔥🔥 关键修复：使用 inputWords 恢复学习进度 🔥🔥🔥
        const unmastered = allWordsInCategory.filter((w) => 
          !allMastered[w.word] && !allMastered[w.word.toLowerCase()]
        );
        console.log(`🔍 过滤后剩余 ${unmastered.length} 个未掌握单词`);

        const shuffledUnmastered = shuffleArray(unmastered);
        
        // 🔥 核心：从服务器获取 inputWords（当前应该学习的单词数量）
        let savedInputWords = 0;
        let savedIndex = 0;
        let lastReviewedWord = null;

        // 尝试从 progressData 中提取关键信息
        if (data.inputWords !== undefined) {
          savedInputWords = data.inputWords;
        }
        if (data.currentWordIndex !== undefined) {
          savedIndex = data.currentWordIndex;
        }
        if (data.lastReviewedWord) {
          lastReviewedWord = data.lastReviewedWord;
        }

        console.log(`📍 恢复状态: inputWords=${savedInputWords}, savedIndex=${savedIndex}, lastWord=${lastReviewedWord}`);

        // 实际可学数 = 总词数 - 已掌握数
        const actualCycleWords = allWordsInCategory.length - Object.keys(allMastered).length;
        const maxAllowed = shuffledUnmastered.length;
        let finalInputWords = 
          savedInputWords > 0 && savedInputWords <= Math.min(maxAllowed, actualCycleWords)
            ? savedInputWords
            : Math.min(maxAllowed, actualCycleWords);
        
        console.log(`📊 finalInputWords=${finalInputWords}, unmastered=${maxAllowed}, actualCycle=${actualCycleWords}, savedInputWords=${savedInputWords}`);

        // 如果savedInputWords比实际未掌握数多，说明有新削词，重置为实际数量
        if (savedInputWords > maxAllowed) {
          finalInputWords = maxAllowed;
          console.log(`⚠️ inputWords(${savedInputWords}) > unmastered(${maxAllowed})，重置为 ${maxAllowed}`);
          // 同步更新服务器的inputWords
          if (getAuthToken()) {
            fetch(`${API_BASE_URL}/api/progress/${targetCategory}`, {
              method: 'POST',
              headers: {
                'Authorization': `Bearer ${getAuthToken()}`,
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                words: progressData,
                sessionLearned: serverSessionLearned,
                inputWords: maxAllowed,
                currentWordIndex: 0,
                lastReviewedWord: null
              })
            }).catch(e => console.warn('更新inputWords失败:', e));
          }
        }
        
        console.log(`📊 finalInputWords=${finalInputWords}, unmastered=${maxAllowed}, savedInputWords=${savedInputWords}`);

        // 确保finalFilteredWords里没有已掌握的单词
        const finalFilteredWords = shuffledUnmastered
          .filter(w => !allMastered[w.word])
          .slice(0, finalInputWords);
        
        console.log(`✅ 过滤已掌握后: ${finalFilteredWords.length} 个单词`);

        console.log(`✅ 最终加载 ${finalFilteredWords.length} 个单词（总共 ${unmastered.length} 个未掌握）`);

        // 7️⃣ 设置状态
        setFilteredWords(finalFilteredWords);
        setDailyProgress(progressData);

        // 8️⃣ 恢复学习位置
        if (finalFilteredWords.length === 0) {
          setCurrentWordIndex(0);
          if (unmastered.length === 0) {
            // 真正全部削词掌握
            setError(`${targetCategory} 类别的单词已全部掌握！`);
          } else {
            // 只是本轮学完，还有未削词的单词
            setError(null);
          }
        } else {
          // 尝试恢复到上次学习的单词
          if (lastReviewedWord) {
            const lastWordIndex = finalFilteredWords.findIndex((w) => w.word === lastReviewedWord);
            if (lastWordIndex !== -1) {
              setCurrentWordIndex(lastWordIndex);
              console.log(`📍 恢复到上次学习的单词: ${lastReviewedWord}, 索引: ${lastWordIndex}`);
            } else {
              const safeIndex = Math.min(savedIndex, finalFilteredWords.length - 1);
              setCurrentWordIndex(safeIndex);
              console.log(`📍 使用保存的索引: ${safeIndex}`);
            }
          } else {
            const safeIndex = Math.min(savedIndex, finalFilteredWords.length - 1);
            setCurrentWordIndex(safeIndex);
          }
          setError(null);
        }

        console.log('✅ 用户进度加载成功');
        setIsDataLoaded(true);
      } catch (error) {
        console.error('❌ 加载用户进度失败:', error);
        setError('加载进度失败: ' + error.message);
      }
    },
    [words, updateMasteredState, shuffleArray, setError, setSessionLearnedWords, setFilteredWords, setCurrentWordIndex, setDailyProgress, setIsDataLoaded]
  );

  const loadCompletedCounts = useCallback(
    async (userId) => {
      try {
        console.log(`加载用户 ${userId} 的完成次数`);
        
        const response = await fetch(`${API_BASE_URL}/api/progress/stats/completed`, {
          headers: {
            'Authorization': `Bearer ${getAuthToken()}`
          }
        });

        if (!response.ok) {
          throw new Error('加载完成次数失败');
        }

        const counts = await response.json();
        setCompletedCounts(counts);
        console.log('加载完成次数成功:', counts);
      } catch (err) {
        console.error('加载完成次数失败:', err);
        setError(`加载完成次数失败: ${err.message}`);
      }
    },
    []
  );

  // === 优化的级别切换功能 ===
  const handleCategoryChange = useCallback(
    async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const newCategory = e.target.value;
      if (newCategory === category) return;

      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = '';
        audioRef.current = null;
        console.log('切换级别前停止音频播放');
      }

      if (filteredWords.length === 0) {
        console.log(`当前级别已完成，直接切换到: ${newCategory}`);
        // 先清空filteredWords，避免保存时用了旧数据
        setFilteredWords([]);
        setDailyProgress({});
        updateMasteredState({
          mastered: {},
          manual: {},
          learned: {}
        });
        setCurrentWordIndex(0);
        setInputValue('');
        setError(null);
        setIsDataLoaded(false);        
        setCategory(newCategory);

        localStorage.setItem('lastCategory', newCategory);
        if (user) {
          await loadUserProgress(user.uid, newCategory);
        } else {
          setFilteredWords([]);
        }
        if (inputRef.current && e.target.tagName !== 'SELECT') {
          inputRef.current.focus();
          console.log('级别切换后输入框聚焦');
        }
        return;
      }

      console.log(`选择级别: ${newCategory}`);
      try {
        if (user) {
          const saveSuccess = await saveAllProgress(category);
          if (!saveSuccess) {
            setError('保存当前级别进度失败，请重试');
            return;
          }
        }
        setDailyProgress({});
        updateMasteredState({
          mastered: {},
          manual: {},
          learned: {}
        });
        setCurrentWordIndex(0);
        setInputValue('');
        setError(null);
        setIsDataLoaded(false);
        
        setCategory(newCategory);
        localStorage.setItem('lastCategory', newCategory);
        if (user) {
          await loadUserProgress(user.uid, newCategory);
        } else {
          setFilteredWords([]);
        }
        if (inputRef.current && e.target.tagName !== 'SELECT') {
          inputRef.current.focus();
          console.log('级别切换后输入框聚焦');
        }
      } catch (err) {
        console.error('级别切换失败:', err);
        setError(`级别切换失败: ${err.message}`);
      }
    },
    [user, category, saveAllProgress, loadUserProgress, filteredWords, updateMasteredState]
  );

  // === 登出功能 ===
  const handleLogout = async () => {
    setKeyboardSound(false); // 登出时关闭音效
    try {
      if (user && (filteredWords.length > 0 || Object.keys(dailyProgress).length > 0)) {
        console.log('登出前保存完整进度...');
        const saveSuccess = await saveAllProgress(category);
        if (!saveSuccess) {
          setError('保存进度失败，请重试后再登出');
          return;
        }
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
      
      setAuthToken(null);
      localStorage.removeItem('userEmail');
      localStorage.removeItem('displayName');
      localStorage.removeItem('photoURL');
      
      console.log('登出成功');
      setUser(null);
      setDailyProgress({});
      updateMasteredState({
        mastered: {},
        manual: {},
        learned: {}
      });
      setCompletedCounts({});
      setCurrentWordIndex(0);
      setIsDataLoaded(false); // ✅ 重置数据加载状态

      const filtered = words.filter((w) => {
        if (Array.isArray(w.category)) {
          return w.category.some(cat => 
            String(cat).toLowerCase().trim() === category.toLowerCase().trim()
          );
        }
        return String(w.category || '').toLowerCase().trim() === category.toLowerCase().trim();
      });
      const shuffledFiltered = shuffleArray(filtered);
      setFilteredWords(shuffledFiltered);

      if (filtered.length === 0 && words.length > 0) {
        setError(`无 ${category} 级别的未掌握单词`);
      }
    } catch (err) {
      console.error('登出失败:', err);
      setError('登出失败: ' + err.message);
    }
  };  

  const getCumulativeMasteredWords = useCallback(
  async (targetCategory) => {
    return { manualMastered: {}, learnedMastered: {} };
  },
  []
);

  // === 重置类别功能 ===
  const resetCategory = useCallback(
    async (categoryToReset) => {
      if (!user) {
        setError('请先登录');
        return;
      }

      try {
        console.log(`重置类别: ${categoryToReset}`);
        
        // 调用后端 API 删除该类别的所有进度
        const response = await fetch(`${API_BASE_URL}/api/progress/${categoryToReset}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${getAuthToken()}`
          }
        });

        if (!response.ok) {
          throw new Error('重置失败');
        }

        // 如果是当前类别，重新加载
        if (category === categoryToReset) {
          await loadUserProgress(user.uid, categoryToReset);
        }

        console.log(`类别 ${categoryToReset} 重置成功`);
      } catch (err) {
        console.error('重置类别失败:', err);
        setError(`重置失败: ${err.message}`);
      }
    },
    [user, category, loadUserProgress]
  );

  // 在 handleInputChange 函数开头添加字符标准化函数
const normalizeText = (text) => {
  return text
    .trim()
    .toLowerCase()
    // 将所有类型的引号/撇号统一为普通单引号
    .replace(/['']/g, "'")
    // 将所有类型的双引号统一
    .replace(/[""]/g, '"')
    // 移除零宽字符
    .replace(/[\u200B-\u200D\uFEFF]/g, '');
};

// 修改后的 handleInputChange 函数（关键部分）
const handleInputChange = useCallback(
  async (e) => {
    // 🚫 例句展示期间禁止输入，避免音频叠加播放
    if (showExampleAfterCorrect) {
      return;
    }

    const rawInput = e.target.value;
    
    // ✅ 使用标准化函数处理输入
    const processedInput = normalizeText(rawInput);

    if (keyboardSound) {
      if (rawInput.length < inputValue.length) {
        playKeySound('Backspace');
      } else if (rawInput.endsWith(' ')) {
        playKeySound(' ');
      } else if (rawInput.length > inputValue.length) {
        playKeySound('normal');
      }
    }

    setInputValue(rawInput);

    const currentWordData = filteredWords[currentWordIndex];
    if (!currentWordData || filteredWords.length === 0) return;

    // ===== 削词模式逻辑 =====
    if (uiState.isInMasterMode && uiState.masterModeWord === currentWordData.word) {
      // ✅ 标准化目标单词
      const targetWord = normalizeText(currentWordData.word);
      const trimmedInput = normalizeText(rawInput);
      
      // 检查输入是否完全正确
      if (trimmedInput === targetWord && trimmedInput.length === targetWord.length) {
        const wordToMaster = uiState.masterModeWord;
        if (wordToMaster) {
          console.log(`削词输入正确，准备执行削词：${wordToMaster}`);
          await executeMasterWord(wordToMaster);
        }
        return;
      }
      
      // 检查输入是否有错误
      if (trimmedInput.length > 0 && !targetWord.startsWith(trimmedInput)) {
        alert('输入有误，已退出削词模式');
        updateUiState({
          isInMasterMode: false,
          masterModeWord: '',
          masterModeFailedWords: {
            ...uiState.masterModeFailedWords,
            [currentWordData.word]: true
          }
        });
        setInputValue('');
        if (inputRef.current) {
          inputRef.current.focus();
        }
        return;
      }
      
      return;
    }

    // ===== 正常学习模式逻辑 =====
    if (inputTimerRef.current) {
      clearTimeout(inputTimerRef.current);
      inputTimerRef.current = null;
    }

    updateUiState({ isInputIncorrect: false });

    if (rawInput.trim().length > 0) {
      inputTimerRef.current = setTimeout(() => {
        if (currentWordData && rawInput.trim().length > 0) {
          // ✅ 标准化处理
          const targetWord = normalizeText(currentWordData.word);
          const targetChinese = currentWordData.meaning_cn 
            ? normalizeText(currentWordData.meaning_cn) 
            : '';

          const isExactEnglishMatch = 
            processedInput === targetWord && 
            processedInput.length === targetWord.length;
          const isExactChineseMatch = 
            targetChinese && 
            processedInput === targetChinese && 
            processedInput.length === targetChinese.length;
          const isCorrect = isExactEnglishMatch || isExactChineseMatch;

          if (!isCorrect) {
            updateUiState({ isInputIncorrect: true });
          }
        }
      }, 2000);
    }

    console.log(`输入: "${processedInput}", 单词: "${normalizeText(currentWordData.word)}"`);

    // ✅ 最终匹配判断
    const targetWord = normalizeText(currentWordData.word);
    const targetChinese = currentWordData.meaning_cn 
      ? normalizeText(currentWordData.meaning_cn) 
      : '';

    const isExactEnglishMatch = 
      processedInput === targetWord && 
      processedInput.length === targetWord.length;
    const isExactChineseMatch = 
      targetChinese && 
      processedInput === targetChinese && 
      processedInput.length === targetChinese.length;

    const isCorrect = isExactEnglishMatch || isExactChineseMatch;

    console.log(`标准化匹配结果: English=${isExactEnglishMatch}, Chinese=${isExactChineseMatch}, Final=${isCorrect}`);

    if (processedInput.length > 0 && !isCorrect) {
      updateUiState({ isIncorrectWord: true });
      if (keyboardSound) playErrorSound();
      setTimeout(() => updateUiState({ isIncorrectWord: false }), 1000);
    } else {
      updateUiState({ isIncorrectWord: false });
    }

    if (isCorrect) {
      console.log('✅ 输入正确，开始处理...');
      if (keyboardSound) playCorrectSound();
      // 先记录单词位置，再触发动画
      console.log('🎬 动画触发检查:', {
        wordRefExists: !!wordRef.current,
        word: currentWordData.word,
      });
      if (wordRef.current) {
        const r = wordRef.current.getBoundingClientRect();
        console.log('📐 单词位置:', { top: r.top, left: r.left, width: r.width, height: r.height });
        setWordRect({ top: r.top, left: r.left, width: r.width, height: r.height });
        setSplitWord(currentWordData.word);
        setWordSplitAnim(true);
        console.log('✅ 动画已触发');
        setTimeout(() => {
          setWordSplitAnim(false);
          setWordRect(null);
        }, 900);
      } else {
        console.log('❌ wordRef.current 为空！');
      }
      // 延迟300ms再处理单词切换
      await new Promise(resolve => setTimeout(resolve, 300));

      // 🎯 学用法模式：展示例句 + 自动播放音频（支持暂停打断）
      if (studyMode === 'usage' && currentWordData.example_en) {
        setShowExampleAfterCorrect(true);
        setIsExamplePaused(false);
        setIsExampleLooping(false);
        isExampleLoopingRef.current = false;
        const exampleAudioPath = pronunciationType === 'uk'
          ? (currentWordData.example_audio_uk || currentWordData.example_audio_us)
          : (currentWordData.example_audio_us || currentWordData.example_audio_uk);
        
        let audioDuration = 0;
        if (exampleAudioPath && autoPlay) {
          try {
            const probeAudio = new Audio(exampleAudioPath);
            await new Promise((resolve) => {
              probeAudio.addEventListener('loadedmetadata', () => {
                audioDuration = probeAudio.duration * 1000;
                resolve();
              });
              probeAudio.addEventListener('error', () => resolve());
              setTimeout(resolve, 1000);
            });
            playExampleAudio(exampleAudioPath, null);
          } catch (e) {
            console.log('例句音频加载失败:', e);
          }
        }

        let displayTime;
        if (audioDuration > 0) {
          displayTime = Math.min(Math.max(audioDuration * 2 * exampleSpeedMultiplier, 1800), 30000);
        } else {
          const wordCount = currentWordData.example_en.split(' ').length;
          const readTime = (wordCount / 150) * 60 * 1000;
          displayTime = Math.min(Math.max(readTime * 2 * exampleSpeedMultiplier, 1800), 30000);
        }
        
        // 用Promise包裹计时器，让resolve函数能被暂停/继续逻辑控制
        await new Promise((resolve) => {
          exampleResolveRef.current = resolve;
          startExampleTimer(displayTime);
        });
      }

        updateUiState({ showLoading: false });
        const now = new Date().getTime();

        const progress = dailyProgress[currentWordData.word] || { reviewCount: 0 };
        const reviewCount = (progress.reviewCount || 0) + 1;

        // 添加到本次会话已学习列表
        const newSessionLearnedWords = [...sessionLearnedWords, currentWordData.word];
        setSessionLearnedWords(newSessionLearnedWords);
        localStorage.setItem(
          `session_learned_${category}`,
          JSON.stringify(newSessionLearnedWords)
        );

        const newFilteredWords = filteredWords.filter((w) => w.word !== currentWordData.word);

        if (user) {
          // 更新本地进度
          const updatedDailyProgress = {
            ...dailyProgress,
            [currentWordData.word]: {
              reviewCount,
              lastReviewed: now,
              manualMaster: false,
            },
          };
          setDailyProgress(updatedDailyProgress);

          // === 关键：实时把 words + sessionLearned 一起保存到服务器 ===
          fetch(`${API_BASE_URL}/api/progress/${category}`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${getAuthToken()}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              words: updatedDailyProgress,           // 所有单词进度
              sessionLearned: newSessionLearnedWords, // 本次会话已学的单词（最关键！）
            }),
          })
            .then((res) => {
              if (!res.ok) throw new Error('保存失败');
              console.log('✅ 会话进度实时保存成功');
            })
            .catch((err) => {
              console.error('实时保存会话进度失败（不影响继续学习）:', err);
              // 即使失败也不中断学习体验
            });
        }

        // 清除削词失败记录
        if (uiState.masterModeFailedWords[currentWordData.word]) {
          const newFailedWords = { ...uiState.masterModeFailedWords };
          delete newFailedWords[currentWordData.word];
          updateUiState({ masterModeFailedWords: newFailedWords });
          setError(null);
        }

        setFilteredWords(newFilteredWords);
        setInputValue('');

        if (newFilteredWords.length > 0) {
          setCurrentWordIndex((prev) => (prev < newFilteredWords.length ? prev : 0));
        } else {
          setCurrentWordIndex(0);
          if (words.length > 0) {
            setError(`无 ${category} 类别的未掌握单词`);
          }
        }

        if (inputRef.current) {
          inputRef.current.focus();
        }

        console.log('✅ handleInputChange 处理完成');
      }
    },
    [
      exampleSpeedMultiplier,
      playExampleAudio,
      startExampleTimer,
      currentWordIndex,
      filteredWords,
      dailyProgress,
      user,
      category,
      words,
      inputValue.length,
      keyboardSound,
      playKeySound,
      playErrorSound,
      playCorrectSound,
      updateUiState,
      uiState.isInMasterMode,
      uiState.masterModeWord,
      uiState.masterModeFailedWords,
      executeMasterWord,
      sessionLearnedWords,
      studyMode,
      pronunciationType,
      showExampleAfterCorrect,
      autoPlay,
    ]
  );

  // === 事件处理函数 ===
  const handleInputBlur = useCallback(
    (e) => {
      const now = Date.now();
      if (now - lastBlurTimeRef.current < 200) {
        console.log('忽略快速重复失焦事件');
        return;
      }
      lastBlurTimeRef.current = now;

      if (
        e.relatedTarget &&
        (e.relatedTarget.tagName === 'SELECT' ||
          emailInputRef.current?.contains(e.relatedTarget) ||
          passwordInputRef.current?.contains(e.relatedTarget))
      ) {
        console.log('忽略由 select 或登录输入框触发的失焦事件');
        updateUiState({ isWordInputFocused: false });
        return;
      }

      if (inputRef.current && uiState.isWordInputFocused && !document.activeElement?.tagName.startsWith('INPUT')) {
        console.log('单词输入框失去焦点，触发重新聚焦');
        blurTimeoutRef.current = setTimeout(() => {
          if (inputRef.current && !document.activeElement?.tagName.startsWith('INPUT')) {
            inputRef.current.focus();
            console.log('单词输入框重新聚焦');
          }
        }, 200);
      }
    },
    [uiState.isWordInputFocused, updateUiState]
  );

  const handleLoginFocus = () => {
    updateUiState({ isWordInputFocused: false });
    console.log('登录/注册输入框聚焦，禁用单词输入框自动聚焦');
  };

  const handleSelectEvent = useCallback((e) => {
    e.stopPropagation();
    console.log(`select 事件: ${e.type}`);
  }, []);

  const handleFirstInteraction = useCallback(() => {
    if (!interaction) {
      setInteraction(true);
      console.log('首次交互，启用自动播放');
      
      // 学句子页面不触发单词自动播放
      if (studyMode === 'sentence') return;

      // 立即尝试播放当前单词
      if (autoPlay && filteredWords.length > 0 && currentWordIndex < filteredWords.length) {
        const currentWordData = filteredWords[currentWordIndex];
        if (currentWordData.audio?.[pronunciationType] && currentWordData.audio[pronunciationType] !== '') {
          setTimeout(() => {
            playAudio(currentWordData.audio[pronunciationType], currentWordData.word, false);
          }, 100);
        }
      }
    }
  }, [interaction, autoPlay, filteredWords, currentWordIndex, pronunciationType, playAudio, studyMode]);

  // === 认证功能 ===
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email) {
      setAuthError('请填邮箱地址');
      return;
    }
    try {
      const response = await authAPI.login(email, password);
      
      // 保存 token
      setAuthToken(response.token);
      localStorage.setItem('userEmail', email);
      
      // 设置用户对象
      const user = {
        uid: response.userId,
        email: email,
      };
      setUser(user);
      
      // ✅ 添加：设置用户资料
      setUserProfile({
        displayName: response.displayName || '',
        photoURL: response.photoURL || '',
      });
      
      console.log('登录成功:', email, { uid: response.userId });
      setEmail('');
      setPassword('');
      setAuthError(null);
      setShowLoginModal(false); // ← 登录成功关闭弹窗
      
      // 加载用户数据
      await loadUserProgress(user.uid, category);
      await loadCompletedCounts(user.uid);
    } catch (err) {
      console.error('登录失败:', err);
      setAuthError('登录失败: ' + err.message);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!email) {
      setAuthError('请填邮箱地址');
      return;
    }
    try {
      const response = await authAPI.register(email, password);
      
      // 保存 token
      setAuthToken(response.token);
      localStorage.setItem('userEmail', email);
      
      // 设置用户对象
      const user = {
        uid: response.userId,
        email: email,
      };
      setUser(user);
      
      console.log('注册成功:', email, { uid: response.userId });
      setEmail('');
      setPassword('');
      setAuthError(null);
      setShowLoginModal(false); // ← 注册成功关闭弹窗
      
      // 加载用户数据
      await loadUserProgress(user.uid, category);
      await loadCompletedCounts(user.uid);
    } catch (err) {
      console.error('注册失败:', err);
      setAuthError('注册失败: ' + err.message);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (!email) {
      setAuthError('请填写邮箱地址');
      return;
    }
    try {
      await authAPI.resetPassword(email);
      console.log('密码重置邮件已发送:', email);
      setAuthError('密码重置邮件已发送，请检查您的邮箱');
      setEmail('');
      setPassword('');
    } catch (err) {
      console.error('密码重置失败:', err);
      setAuthError('密码重置失败: ' + err.message);
    }
  };

    const filterWords = useCallback(
      () => {
        console.log(`开始过滤单词，当前级别: ${category}`);

        const filtered = words.filter((w) => {
          // 过滤类别
          const matchCategory = Array.isArray(w.category)
            ? w.category.some(cat => String(cat).toLowerCase().trim() === category.toLowerCase().trim())
            : String(w.category || '').toLowerCase().trim() === category.toLowerCase().trim();

          // 🔥 排除已掌握的单词（包括手动削词和学习掌握）
          const isNotMastered = !masteredState.mastered[w.word];

          return matchCategory && isNotMastered;
        });

        console.log(`过滤后单词数: ${filtered.length}, 级别: ${category}`);
        const shuffledFiltered = shuffleArray(filtered);
        setFilteredWords(shuffledFiltered);

        if (filtered.length === 0 && Object.keys(masteredState.mastered).length > 0) {
          setError(`${category} 类别的单词已全部掌握！`);
        } else if (filtered.length === 0) {
          setError(null);
        } else {
          setError(null);
        }
      },
      [words, category, masteredState.mastered, shuffleArray]
    );

  // === useEffect 钩子 ===
  // 处理微信登录回调
  const handleWxLoginSuccess = useCallback(async (token) => {
    try {
      setAuthToken(token);
      const response = await fetch(`${API_BASE_URL}/api/auth/verify`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('验证失败');
      const userData = await response.json();
      const newUser = { uid: userData.userId, email: userData.email };
      setUser(newUser);
      setUserProfile({
        displayName: userData.displayName || userData.wx_nickname || '',
        photoURL: userData.photoURL || userData.wx_avatar || '',
      });
      await loadUserProgress(newUser.uid, category);
      await loadCompletedCounts(newUser.uid);
    } catch(err) {
      console.error('微信登录处理失败:', err);
    }
  }, [category, loadUserProgress, loadCompletedCounts]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const wxToken = params.get('wx_token');
    const wxTempTokenParam = params.get('wx_temp_token');
    const wxLogin = params.get('wx_login');
    const wxError = params.get('wx_error');

    if (wxToken && wxLogin === 'success') {
      // 微信登录成功，自动登录
      handleWxLoginSuccess(wxToken);
      window.history.replaceState({}, '', '/');
    } else if (wxTempTokenParam && wxLogin === 'bind') {
      // 需要绑定或注册
      setWxTempToken(wxTempTokenParam);
      setShowWxBindModal(true);
      setShowLoginModal(false);
      window.history.replaceState({}, '', '/');
    } else if (wxError) {
      console.error('微信登录错误:', wxError);
      window.history.replaceState({}, '', '/');
    }
  }, [handleWxLoginSuccess]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/words/ads`)
      .then(res => res.json())
      .then(data => {
        if (data.ads && data.ads.length > 0) {
          setAdImages(data.ads);
          adImagesRef.current = data.ads;
        }
        adModeRef.current = data.mode || 'random';
        adFixedFileRef.current = data.fixedFile || '';
      })
      .catch(err => console.warn('加载广告列表失败:', err));
  }, []);

  // 广告弹窗：停止操作10分钟后弹出
  useEffect(() => {
    const AD_DELAY = 10 * 60 * 1000; // 保底10分钟无操作

    // 检查今天是否已经弹过
    const hasShownToday = () => {
      const last = localStorage.getItem('adLastShownDate');
      if (!last) return false;
      return last === new Date().toDateString();
    };

    const markShownToday = () => {
      localStorage.setItem('adLastShownDate', new Date().toDateString());
    };

    const tryShowAd = () => {
      if (hasShownToday()) return;
      if (showWordPlayer) return;
      if (greenScreen) return;
      markShownToday();
      // 随机选一张广告图
      const imgs = adImagesRef.current;
      const mode = adModeRef.current;
      const fixedFile = adFixedFileRef.current;
      if (imgs.length > 0) {
        let selectedAd;
        if (mode === 'fixed' && fixedFile) {
          selectedAd = fixedFile;
        } else {
          selectedAd = imgs[Math.floor(Math.random() * imgs.length)];
        }
        console.log('广告模式:', mode, '选中:', selectedAd);
        setCurrentAdImage(selectedAd);
      }
      setShowAdModal(true);
    };

    // 保底：10分钟无操作
    const resetAdTimer = () => {
      if (showWordPlayer) {              // 播放器开着，不计时
        if (adTimerRef.current) {
          clearTimeout(adTimerRef.current);
          adTimerRef.current = null;
        }
        return;
      }
      if (hasShownToday()) return;       // 今天已弹过，不计时
      if (adTimerRef.current) clearTimeout(adTimerRef.current);
      adTimerRef.current = setTimeout(tryShowAd, AD_DELAY);
    };

    const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'];
    events.forEach(event => document.addEventListener(event, resetAdTimer));
    resetAdTimer(); // 页面加载时启动

    return () => {
      events.forEach(event => document.removeEventListener(event, resetAdTimer));
      if (adTimerRef.current) clearTimeout(adTimerRef.current);
    };
  }, [showWordPlayer, greenScreen, adImages]); // ← 依赖 showWordPlayer，播放器开关时自动响应

  // 👇 新增：监听屏幕尺寸变化
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 清理定时器
  useEffect(() => {
    return () => {
      if (inputTimerRef.current) {
        clearTimeout(inputTimerRef.current);
      }
    };
  }, []);

  // 重置输入状态
  useEffect(() => {
    updateUiState({ isInputIncorrect: false });
    if (inputTimerRef.current) {
      clearTimeout(inputTimerRef.current);
      inputTimerRef.current = null;
    }
  }, [currentWordIndex, updateUiState]);

  // 优化的自动播放useEffect
  useEffect(() => {
    if (
      currentPage === 'learning' &&
      studyMode !== 'sentence' &&
      !uiState.searchMode &&
      filteredWords.length > 0 &&
      currentWordIndex < filteredWords.length &&
      autoPlay &&
      interaction &&
      !loopPlay
    ) {
      const currentWordData = filteredWords[currentWordIndex];
      if (currentWordData.audio?.[pronunciationType] && currentWordData.audio[pronunciationType] !== '') {
        const timer = setTimeout(() => {
          // ✅ 播放前先停止所有音频
          if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.src = '';
            audioRef.current = null;
          }
          
          // ✅ 创建新的音频实例并保存到 ref
          const audio = new Audio(currentWordData.audio[pronunciationType]);
          audioRef.current = audio;  // 保存引用
          
          const playPromise = audio.play();
          
          if (playPromise !== undefined) {
            playPromise
              .then(() => {
                console.log(`自动播放成功: ${currentWordData.word}`);
              })
              .catch((err) => {
                console.warn(`自动播放被阻止: ${err.message}`);
              });
          }
        }, 300);
        
        // ✅ 清理函数：停止定时器和音频
        return () => {
          clearTimeout(timer);
          if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.src = '';
            audioRef.current = null;
          }
        };
      } else {
        console.log(`无音频可播放: ${currentWordData.word}`);
      }
    }
  }, [currentWordIndex, filteredWords, autoPlay, interaction, loopPlay, currentPage, pronunciationType, uiState.searchMode, studyMode]);

  // 优化的加载状态useEffect
  useEffect(() => {
    updateUiState({ showLoading: false });
        
    if (!currentWord || !inputValue.trim()) return;

    const isComplete =
      inputValue.trim().toLowerCase() === currentWord.word?.toLowerCase() ||
      (currentWord.meaning_cn && inputValue.trim().toLowerCase() === currentWord.meaning_cn.toLowerCase());

    if (isComplete) {
      const timer = setTimeout(() => {
        updateUiState({ showLoading: true });
      }, 2000);
      // return () => clearTimeout(timer); // 这行是否修改有待确认
      return () => {
        clearTimeout(timer);
        // 清理时也停止音频
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.src = '';
          audioRef.current = null;
        }
      };
    }
  }, [inputValue, currentWord, updateUiState]);

  // 认证状态监听
  useEffect(() => {
    const token = getAuthToken();
    
    if (token && !isLoadingUser && !user && words.length > 0) {
    const loadUser = async () => {
      setIsLoadingUser(true);
      try {
        const response = await fetch(`${API_BASE_URL}/api/auth/verify`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (!response.ok) {
          throw new Error('Token 验证失败');
        }
        
        const userData = await response.json();
        
        // ✅ 确保这里正确设置
        const mockUser = {
          uid: userData.userId,
          email: userData.email,
        };
        
        setUser(mockUser);
        console.log('用户已登录:', mockUser.email);
        
        // ✅ 关键：确保这里设置了 userProfile
        setUserProfile({
          displayName: userData.displayName || '',
          photoURL: userData.photoURL || '',
        });
        
        // 加载进度数据
        await loadUserProgress(mockUser.uid, category);
        await loadCompletedCounts(mockUser.uid);
        
        console.log('用户数据加载完成');
      } catch (err) {
        console.error('加载用户数据失败:', err);
        setAuthToken(null);
        localStorage.clear();
        setUser(null);
      } finally {
        setIsLoadingUser(false);
      }
    };
    
    loadUser();
  } else if (!token && !isLoadingUser) {
      console.log('用户未登录');
      setUserProfile({ displayName: '', photoURL: '' });
      setDailyProgress({});
      updateMasteredState({
        mastered: {},
        manual: {},
        learned: {}
      });
      setCompletedCounts({});
      setCurrentWordIndex(0);
      
      // ✅ 只有在 words 加载完成后才过滤
      if (words.length > 0) {
        const filtered = words.filter((w) => {
          if (Array.isArray(w.category)) {
            return w.category.some(cat => 
              String(cat).toLowerCase().trim() === category.toLowerCase().trim()
            );
          }
          return String(w.category || '').toLowerCase().trim() === category.toLowerCase().trim();
        });
        const shuffledFiltered = shuffleArray(filtered);
        setFilteredWords(shuffledFiltered);
        
        if (filtered.length === 0) {
          setError(`无 ${category} 类别的单词`);
        } else {
          setError(null);
        }
      }
    }
  }, [category, words, user, isLoadingUser, loadUserProgress, loadCompletedCounts, updateMasteredState, shuffleArray]);  // ✅ 添加 words 依赖

  // 加载单词数据（方案B：优先从API动态加载，失败则降级到words.json）
  useEffect(() => {
    console.log('开始加载单词数据，级别:', category);
    const fetchWords = async () => {
      try {
        // 第一步：尝试从API加载当前级别单词
        const apiResponse = await fetch(`${API_BASE_URL}/api/words/category/${category}`);
        
        let data = [];
        
        if (apiResponse.ok) {
          const apiData = await apiResponse.json();
          data = apiData.words || [];
          console.log(`从API加载单词成功，级别: ${category}，单词数: ${data.length}`);
        } else {
          throw new Error('API加载失败，降级到words.json');
        }

        // 第二步：加载全量words.json用于统计（categories词数显示）
        try {
          const jsonResponse = await fetch('/words.json');
          if (jsonResponse.ok) {
            const allWords = await jsonResponse.json();
            // 把API最新数据合并进去：替换同级别的旧单词，保留其他级别
            const otherWords = allWords.filter(w => {
              const cats = Array.isArray(w.category) ? w.category : [w.category];
              return !cats.some(c => String(c).toLowerCase().trim() === category.toLowerCase().trim());
            });
            const mergedWords = [...otherWords, ...data];
            setWords(mergedWords);
            console.log('合并后总单词数:', mergedWords.length);
          }
        } catch (e) {
          // words.json加载失败，直接用API数据作为words
          console.warn('words.json加载失败，直接使用API数据');
          setWords(data);
        }

        // 第三步：用API数据更新当前级别的filteredWords（未登录时）
        if (!user) {
          const shuffledData = shuffleArray(data);
          setFilteredWords(shuffledData);
          if (data.length === 0) {
            setError(`无 ${category} 类别的未掌握单词`);
          } else {
            setError(null);
          }
        }

      } catch (error) {
        // 降级：从words.json加载
        console.warn('API加载失败，降级到words.json:', error.message);
        try {
          const response = await fetch('/words.json');
          if (!response.ok) {
            throw new Error(`HTTP 错误: ${response.status} ${response.statusText}`);
          }
          const allWords = await response.json();
          console.log('降级加载 words.json 成功，单词数:', allWords.length);
          setWords(allWords);
          if (!user) {
            const filtered = allWords.filter((w) => {
              if (Array.isArray(w.category)) {
                return w.category.some(cat =>
                  String(cat).toLowerCase().trim() === category.toLowerCase().trim()
                );
              }
              return String(w.category || '').toLowerCase().trim() === category.toLowerCase().trim();
            });
            const shuffledFiltered = shuffleArray(filtered);
            setFilteredWords(shuffledFiltered);
            if (filtered.length === 0 && allWords.length > 0) {
              setError(`无 ${category} 类别的未掌握单词`);
            } else {
              setError(null);
            }
          }
        } catch (fallbackError) {
          console.error('words.json 也加载失败:', fallbackError);
          setError(`数据加载失败: ${fallbackError.message}`);
        }
      }
    };

    fetchWords();
  }, [category, shuffleArray, user]);

  // 过滤单词
  useEffect(() => {
    if (words.length > 0 && !user) {
      filterWords();
    }
  }, [category, words, masteredState.mastered, filterWords, user]);

  // 键盘事件监听
  useEffect(() => {
    // 定义完成学习的处理函数
    const handleComplete = async () => {
      if (isCompletingRef.current) {
        console.log('正在处理完成操作，忽略');
        return;
      }

      // 🔥 关键：不再检查 hasCompletedThisCycle，直接判断是否有单词需要学习
      if (filteredWords.length === 0 && sessionLearnedWords.length > 0 && user) {
        isCompletingRef.current = true;
        console.log('🎯 开始完成学习流程...');

        try {
          console.log(`🎯 完成 ${category} 级别学习`);
          
          // 1️⃣ 记录完成次数
          const response = await fetch(`${API_BASE_URL}/api/progress/stats/complete/${category}`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${getAuthToken()}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              totalWords: progressStats.totalWords
            })
          });
          
          if (!response.ok) throw new Error('记录完成失败');
          console.log('✅ 完成次数已记录');

          // 2️⃣ 🔥🔥🔥 清空服务器端的会话记录 🔥🔥🔥
          console.log(`🧹 准备清空 ${category} 的服务器会话记录...`);
          const clearResponse = await fetch(`${API_BASE_URL}/api/progress/${category}/session`, {
            method: 'DELETE',
            headers: {
              'Authorization': `Bearer ${getAuthToken()}`
            }
          });
          
          console.log('🔍 清空会话记录响应状态:', clearResponse.status);
          
          if (clearResponse.ok) {
            const clearResult = await clearResponse.json();
            console.log('✅ 服务器会话记录已清空:', clearResult);
          } else {
            const errorText = await clearResponse.text();
            console.error('❌ 清空失败:', clearResponse.status, errorText);
          }

          // 3️⃣ 重新加载完成次数
          const countsResponse = await fetch(`${API_BASE_URL}/api/progress/stats/completed`, {
            headers: {
              'Authorization': `Bearer ${getAuthToken()}`
            }
          });
          if (countsResponse.ok) {
            const counts = await countsResponse.json();
            setCompletedCounts(counts);
            console.log('✅ 完成次数已更新');
          }

          // 4️⃣ 重置本地状态
          console.log('🔄 重置本地状态...');
          setDailyProgress({});
          updateMasteredState({ mastered: {}, manual: {}, learned: {} });
          setCurrentWordIndex(0);
          setSessionLearnedWords([]);
          localStorage.removeItem(`session_learned_${category}`);
          console.log('✅ 本地状态已重置');

          // 烟花已在"恭喜"页面触发，此处不再重复

          // 🎯 第二步：延迟1.5秒弹广告（让用户先看烟花）
          const adLastShown = localStorage.getItem('adLastShownDate');
          const shownToday = adLastShown === new Date().toDateString();
          if (!shownToday && !showWordPlayer) {
            localStorage.setItem('adLastShownDate', new Date().toDateString());
            setTimeout(() => setShowAdModal(true), 1500);
          }

          // 5️⃣ 第三步：延迟2秒再重新加载，让烟花先播放
          console.log('⏳ 等待 2 秒后重新加载...');
          await new Promise(resolve => setTimeout(resolve, 2000));
          
          console.log('🔄 重新加载用户进度...');
          await loadUserProgress(user.uid, category);
          console.log('✅✅✅ 完成学习流程结束，应该可以继续学习了');
        } catch (err) {
          console.error('❌ 完成学习失败:', err);
          setError(`完成学习失败: ${err.message}`);
        } finally {
          setTimeout(() => {
            isCompletingRef.current = false;
            console.log('🔓 重置完成标记');
          }, 1000);
        }
      }
    };

    // 键盘事件处理器
    const handleKeyPress = (e) => {
      console.log('🔍 按键事件:', e.key);

      // Ctrl + L: 进入播放单词模式
      if (e.ctrlKey && e.key.toLowerCase() === 'l') {
        e.preventDefault();
        setShowWordPlayer((prev) => !prev);
        return;
      }

      // Ctrl + G: 切换绿屏模式
      if (e.ctrlKey && e.key.toLowerCase() === 'g') {
        e.preventDefault();
        setGreenScreen((prev) => {
          const next = !prev;
          if (next) setShowQRCode(true);  // 进入绿屏自动展开二维码
          return next;
        });
        return;
      }
      
      // Ctrl + X: 进入削词模式（仅学单词页生效）
      if (e.ctrlKey && e.key.toLowerCase() === 'x' && studyMode === 'word') {
        e.preventDefault();
        if (user && filteredWords.length > 0 && currentWordIndex < filteredWords.length) {
          const currentWordData = filteredWords[currentWordIndex];
          handleManualMaster(currentWordData.word);
        }
        return;
      }
      
      // Ctrl + C: 退出削词模式（仅学单词页生效）
      if (e.ctrlKey && e.key.toLowerCase() === 'c' && studyMode === 'word') {
        e.preventDefault();
        if (uiState.isInMasterMode) {
          if (keyboardSound) playSwordSound('close02.wav');
          updateUiState({
            isInMasterMode: false,
            masterModeWord: ''
          });
          setInputValue('');
          if (inputRef.current) {
            inputRef.current.focus();
          }
        }
        return;
      }

      // Ctrl + X: 进入削句模式（仅学句子页生效）
      if (e.ctrlKey && e.key.toLowerCase() === 'x' && studyMode === 'sentence') {
        e.preventDefault();
        if (user && !isInSentenceMasterMode) {
          setIsInSentenceMasterMode(true);
          setSentenceInput('');
          setAutoPlayAudio(true);
          const cs = sentences[currentSentenceIndex];
          if (cs) {
            const url = getSentenceAudioPath(cs, sentenceAudioType);
            const fullUrl = resolveAudioFullUrl(url);
            if (fullUrl) {
              new Audio(fullUrl).play().catch(() => {});
            }
          }
        }
        return;
      }

      // Ctrl + C: 退出削句模式（仅学句子页生效）
      if (e.ctrlKey && e.key.toLowerCase() === 'c' && studyMode === 'sentence') {
        e.preventDefault();
        if (isInSentenceMasterMode) {
          setIsInSentenceMasterMode(false);
          setSentenceInput('');
        }
        return;
      }

      // 🔥 完成学习：当无单词可学且有会话记录时，按任意键触发
      if (
        filteredWords.length === 0 &&
        sessionLearnedWords.length > 0 &&
        user &&
        (e.key.length === 1 || e.key === 'Enter' || e.key === 'Backspace' || e.key === ' ')
      ) {
        e.preventDefault();
        console.log('✅ 触发完成学习');
        handleComplete();
      }
    };

    // 添加监听器
    document.addEventListener('keydown', handleKeyPress);

    // 清理函数
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      console.log('清理键盘监听器');
    };
  }, [
    filteredWords,
    sessionLearnedWords,
    user,
    category,
    currentWordIndex,
    uiState.isInMasterMode,
    handleManualMaster,
    updateUiState,
    progressStats.totalWords,
    updateMasteredState,
    loadUserProgress,
    showWordPlayer,
    keyboardSound,
    playSwordSound,
    studyMode,
    isInSentenceMasterMode,
    sentences,
    currentSentenceIndex,
    sentenceAudioType,
  ]);

  // 页面卸载处理
  useEffect(() => {
    const handleBeforeUnload = async (event) => {
      if (user && Object.keys(dailyProgress).length > 0) {
        console.log('页面卸载，保存进度到 Firebase');
        event.preventDefault();
        event.returnValue = '';
        
        try {
          await saveAllProgress(category);
        } catch (err) {
          console.error('页面卸载时保存失败:', err);
        }
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [user, category, dailyProgress, saveAllProgress]);

  // 首次交互监听
  useEffect(() => {
    document.addEventListener('click', handleFirstInteraction);
    return () => document.removeEventListener('click', handleFirstInteraction);
  }, [handleFirstInteraction]);

  // 加载句子分类列表（不再依赖是否已进入学句子页面，避免单词播放器在其他页面打开时因为来源列表为空而报“暂无句子”）
  useEffect(() => {
    sentencesAPI.getSources().then(data => {
      setSentenceSources(data.sources || []);
      if (!currentSource && data.sources && data.sources.length > 0) {
        setCurrentSource(data.sources[0]);
      }
    }).catch(err => console.error('加载句子分类失败:', err));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 加载当前分类的句子列表
  useEffect(() => {
    if (studyMode !== 'sentence' || !currentSource) return;
    setIsSentencesLoading(true);
    sentencesAPI.getBySource(currentSource).then(async data => {
      const allSentences = data.sentences || [];
      // 如果已登录，获取进度过滤已掌握的
      if (user) {
        try {
          const progress = await sentencesAPI.getProgress(currentSource);
          const mastered = progress.mastered || {};
          setMasteredSentences(mastered);
          const unmastered = allSentences.filter(s => !mastered[s.id]);
          setSentences(unmastered.length > 0 ? unmastered : allSentences);
        } catch {
          setSentences(allSentences);
        }
      } else {
        setSentences(allSentences);
      }
      setCurrentSentenceIndex(0);
      setSentenceInput('');
      setIsSentenceCorrect(false);
      setIsInSentenceMasterMode(false);
      setIsSentencesLoading(false);
    }).catch(err => {
      console.error('加载句子失败:', err);
      setIsSentencesLoading(false);
    });
  }, [currentSource, studyMode, user]);

  // 页面标题设置
  useEffect(() => {
    const categoryLabels = {
      elementary: '小学 (300-1000 词)',
      junior: '初中 (1000-1500 词)',
      highschool: '高中 (1500-3500 词)',
      cet4: '四级 (~4500 词)',
      cet6: '六级 (~6000 词)',
      toefl: '考研/托福 (~8000-10000 词)',
      ielts_gre: '雅思/GRE (~10000-15000 词)',
    };
    
    // 只修改title，不修改description
    document.title = `削词侠 - ${categoryLabels[category] || '英语词汇学习'}`;
  }, [category]);

  // === 渲染部分 ===
  // About页面渲染
  if (currentPage === 'about') {
    return <About onBack={() => setCurrentPage('learning')} />;
  }

  // Contact页面渲染
  if (currentPage === 'contact') {
    return <Contact onBack={() => setCurrentPage('learning')} onNavigate={setCurrentPage} />;
  }

  // PrivacyPolicy页面渲染
  if (currentPage === 'privacy') {
    return <PrivacyPolicy onBack={() => setCurrentPage('learning')} />;
  }

  if (currentPage === 'faq') {
    return <FAQ onBack={() => setCurrentPage('learning')} />;
  }

  // PersonalCenter页面渲染
  if (currentPage === 'personal' && user) {
    return (
      <Suspense fallback={<div>加载中...</div>}>
        <PersonalCenter
          user={user}
          categories={categories}
          completedCounts={completedCounts}
          words={words}
          onBack={() => setCurrentPage('learning')}
          getCumulativeMasteredWords={getCumulativeMasteredWords}
          userProfile={userProfile}
          setUserProfile={setUserProfile}
          onResetCategory={resetCategory}
        />
      </Suspense>
    );
  }

  

  // === 主题颜色定义 ===
  const themeColors = {
    light: {
      background: '#ffffff',
      text: '#000000',
      secondaryText: '#666666',
      border: '#000000',
      cardBg: '#f9f9f9',
      inputBorder: '#ddd',
      errorBg: '#ffe6e6',
      errorText: 'red',
    },
    dark: {
      background: '#1a1a1a',
      text: '#ffffff',
      secondaryText: '#cccccc',
      border: '#ffffff',
      cardBg: '#2a2a2a',
      inputBorder: '#555',
      errorBg: '#4a1a1a',
      errorText: '#ff6b6b',
    }
  };

  const currentTheme = themeColors[theme];

  // 👇 新增：响应式样式定义（在最后的 return 之前）
  const containerStyle = {
    padding: isMobile ? '10px' : '20px',
    width: '100%',
    margin: '0',
    userSelect: 'text',
    maxWidth: 'none',
    backgroundColor: greenScreen ? '#90EE90' : currentTheme.background,
    color: greenScreen ? '#ffffff' : currentTheme.text,
    minHeight: '100vh',
    transition: 'background-color 0.3s, color 0.3s',
    boxSizing: 'border-box',
  };

  const headerStyle = {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: 'space-between',
    alignItems: isMobile ? 'center' : 'flex-start',
    marginBottom: '20px',
    gap: isMobile ? '15px' : '0',
  };
  const centerSectionStyle = {
    width: isMobile ? '100%' : '50%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  };

  const wordDisplayStyle = {
    fontSize: isMobile ? '2em' : '3em',
    margin: '10px 0',
    letterSpacing: '0.05em',
    wordBreak: 'break-word',
  };

  const inputFieldStyle = {
    border: 'none',
    // borderBottom: `2px solid ${currentTheme.border}`,
    borderBottom: '2px solid #3498db', // 改为蓝色下划线
    borderRadius: '0',
    // width: isMobile ? '100%' : `${(currentWord.word?.length || 10) * 1.5}em`,
    width: isMobile ? '100%' : `${Math.max(currentWord.word?.length || 0, 14) * 1.5}em`,
    maxWidth: isMobile ? '300px' : 'none',
    fontSize: isMobile ? '1.2em' : '1.5em',
    textAlign: 'center',
    outline: 'none',
    paddingRight: '0',  // 改为 '0'（已经是正确的）
    color: uiState.isInputIncorrect ? '#3498db' : currentTheme.text,
    backgroundColor: currentTheme.background,
  };

  const buttonContainerStyle = {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    alignItems: 'center',
    gap: isMobile ? '10px' : '20px',
    justifyContent: 'center',
    marginTop: '10px',
  };

  const masterButtonStyle = {
    padding: isMobile ? '10px 15px' : '8px 20px',
    background: 
      user && 
      !uiState.isMasterLoading && 
      !uiState.masterModeFailedWords[currentWord.word]
        ? (uiState.isInMasterMode ? '#52c41a' : '#1890ff')
        : '#d9d9d9',
    color: 
      user && 
      !uiState.isMasterLoading && 
      !uiState.masterModeFailedWords[currentWord.word]
        ? 'white' 
        : '#999',
    border: 'none',
    cursor: 
      user && 
      filteredWords.length > 0 && 
      !uiState.isMasterLoading && 
      !uiState.masterModeFailedWords[currentWord.word]
        ? 'pointer' 
        : 'not-allowed',
    borderRadius: '4px',
    fontSize: isMobile ? '0.9em' : '1em',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: isMobile ? '100%' : '120px',
    maxWidth: isMobile ? '300px' : 'none',
    height: '36px',
  };

  const footerStyle = {
    marginTop: isMobile ? '40px' : '60px',
    paddingTop: '20px',
    borderTop: `1px solid ${theme === 'light' ? '#e0e0e0' : '#444'}`,
    textAlign: 'center',
    color: currentTheme.secondaryText,
    fontSize: isMobile ? '0.8em' : '0.9em',
    display: greenScreen ? 'none' : 'block',
  };

  const footerLinksStyle = {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: 'center',
    gap: isMobile ? '10px' : '30px',
    marginBottom: '15px',
  };

  // 学句子页面渲染
  if (studyMode === 'sentence') {
    const currentSentence = sentences[currentSentenceIndex] || null;
    const unmasteredCount = sentences.length;
    const totalSentencesInSource = sentences.length + Object.keys(masteredSentences).length;
    const masteredCount = Object.keys(masteredSentences).length;
    const studyProgressPercent = totalSentencesInSource > 0
      ? Math.round((unmasteredCount / totalSentencesInSource) * 100)
      : 0;
    const masterProgressPercent = totalSentencesInSource > 0
      ? Math.round((masteredCount / totalSentencesInSource) * 100)
      : 0;

    const handleSentenceInput = (e) => {
      const val = e.target.value;
      setSentenceInput(val);
      if (!currentSentence) return;
      const target = currentSentence.sentence_en.trim().toLowerCase();
      const input = val.trim().toLowerCase();
      if (input === target) {
        setIsSentenceCorrect(true);
        if (keyboardSound) playCorrectSound();
        setTimeout(() => {
          stopSentenceLoop();
          setSentenceLoop(false);
          const next = sentences.filter((_, i) => i !== currentSentenceIndex);
          setSentences(next);
          setCurrentSentenceIndex(prev => Math.min(prev, Math.max(0, next.length - 1)));
          setSentenceInput('');
          setIsSentenceCorrect(false);
          setIsInSentenceMasterMode(false);
          if (autoPlayAudio && next.length > 0) {
            const nextSentence = next[Math.min(currentSentenceIndex, next.length - 1)];
            const url = getSentenceAudioPath(nextSentence, sentenceAudioType);
            const fullUrl = resolveAudioFullUrl(url);
            if (fullUrl) {
              setTimeout(() => new Audio(fullUrl).play().catch(() => {}), 300);
            }
          }
        }, 400);
      }
    };

    const handleSentenceMasterInput = async (e) => {
      const val = e.target.value;
      setSentenceInput(val);
      if (!currentSentence) return;
      const target = currentSentence.sentence_en.trim().toLowerCase();
      const input = val.trim().toLowerCase();
      if (input === target) {
        try {
          await sentencesAPI.masterSentence(currentSource, currentSentence.id);
          setMasteredSentences(prev => ({ ...prev, [currentSentence.id]: true }));
          if (keyboardSound) playMasterSound();
          stopSentenceLoop();
          setSentenceLoop(false);
          const next = sentences.filter((_, i) => i !== currentSentenceIndex);
          setSentences(next);
          setCurrentSentenceIndex(prev => Math.min(prev, Math.max(0, next.length - 1)));
          setSentenceInput('');
          // 削句成功后保持削句模式，连续削句直到用户主动点击"退出削句模式"
          if (autoPlayAudio && next.length > 0) {
            const nextSentence = next[Math.min(currentSentenceIndex, next.length - 1)];
            const url = getSentenceAudioPath(nextSentence, sentenceAudioType);
            const fullUrl = resolveAudioFullUrl(url);
            if (fullUrl) {
              setTimeout(() => new Audio(fullUrl).play().catch(() => {}), 300);
            }
          }
        } catch (err) {
          console.error('削句失败:', err);
        }
      } else if (val.length > 0 && !target.startsWith(input)) {
        // 削句模式下打错不退出，仅抖动提示 + 清空重试
        setIsSentenceInputError(true);
        setSentenceInput('');
        setTimeout(() => setIsSentenceInputError(false), 400);
      }
    };

    const stopSentenceLoop = () => {
      if (sentenceLoopAudioRef.current) {
        const audio = sentenceLoopAudioRef.current;
        if (audio._loopHandler) {
          audio.removeEventListener('ended', audio._loopHandler);
        }
        audio.pause();
        audio.src = '';
        sentenceLoopAudioRef.current = null;
      }
    };

    const playSentenceAudio = (type, loop = false) => {
      if (!currentSentence) return;
      const url = getSentenceAudioPath(currentSentence, type);
      const fullUrl = resolveAudioFullUrl(url);
      if (!fullUrl) return;

      stopSentenceLoop();

      const audio = new Audio(fullUrl);
      if (loop) {
        const onEnded = () => {
          audio.currentTime = 0;
          audio.play().catch(() => {});
        };
        audio.addEventListener('ended', onEnded);
        audio._loopHandler = onEnded; // 保存引用，方便 stopSentenceLoop 精确移除这个监听器
        sentenceLoopAudioRef.current = audio;
      }
      audio.play().catch(() => {});
    };

    return (
      <div
        style={containerStyle}
        className={greenScreen ? 'green-screen-mode' : ''}
        onClick={(e) => {
          if (e.target.closest && e.target.closest('[data-mode-btn]')) return;
          handleFirstInteraction();
        }}
      >
        {/* 绿屏模式覆盖样式（与学单词页面共用同一套规则，之前这个分支缺失导致学句子页绿屏效果不完整） */}
        <style>{`
          .green-screen-mode * {
            color: #ffffff !important;
            border-color: rgba(255,255,255,0.5) !important;
            background-color: transparent !important;
            text-shadow: 
              2px 2px 4px rgba(0,0,0,1),
              -2px -2px 4px rgba(0,0,0,1),
              2px -2px 4px rgba(0,0,0,1),
              -2px 2px 4px rgba(0,0,0,1),
              0 0 10px rgba(0,0,0,0.9) !important;
            font-weight: 700 !important;
          }
          .green-screen-mode p,
          .green-screen-mode span,
          .green-screen-mode label {
            font-size: 1.1em !important;
          }
          .green-screen-mode input {
            background: transparent !important;
            color: #ffffff !important;
            border-bottom-color: rgba(255,255,255,0.8) !important;
          }
          .green-screen-mode input::placeholder {
            color: rgba(255,255,255,0.8) !important;
            text-shadow: 
              1px 1px 3px rgba(0,0,0,0.9),
              0 0 8px rgba(0,0,0,0.8) !important;
          }
          .green-screen-mode select {
            background: transparent !important;
            color: #ffffff !important;
          }
          .green-screen-mode button {
            background: rgba(0,0,0,0.3) !important;
            color: #ffffff !important;
            border: 1px solid rgba(255,255,255,0.4) !important;
          }
          .green-screen-mode .custom-progress::-webkit-progress-bar {
            background: rgba(255,255,255,0.2) !important;
          }
          .green-screen-mode .custom-progress::-webkit-progress-value {
            background: rgba(255,255,255,0.9) !important;
          }
        `}</style>

        {/* ===== 学句子 头部（与学单词页面共用同一组件）===== */}
        <div style={headerStyle}>
          <HeaderTitleSection
            isMobile={isMobile}
            currentTheme={currentTheme}
            isHovering={isHovering}
            setIsHovering={setIsHovering}
            theme={theme}
            toggleTheme={toggleTheme}
            greenScreen={greenScreen}
            setGreenScreen={setGreenScreen}
            setShowQRCode={setShowQRCode}
          />

          {/* 中间区域 */}
          <div style={centerSectionStyle}>
            {/* 当前分类选择器 */}
            <p style={{ 
              fontSize: isMobile ? '1em' : '1.2em', 
              margin: '0 0 10px 0', 
              display: 'flex', alignItems: 'center', 
              justifyContent: 'center', flexWrap: 'wrap', gap: '5px'
            }}>
              当前分类:
              <select
                value={currentSource}
                onChange={e => setCurrentSource(e.target.value)}
                style={{
                  marginLeft: isMobile ? '0' : '10px',
                  marginTop: isMobile ? '5px' : '0',
                  padding: '5px',
                  fontSize: isMobile ? '0.9em' : '1em',
                  border: 'none',
                  borderBottom: `2px solid ${currentTheme.border}`,
                  borderRadius: '0',
                  background: currentTheme.background,
                  color: currentTheme.text,
                  outline: 'none',
                  width: 'auto',
                  maxWidth: isMobile ? '250px' : 'none',
                  textAlign: 'center',
                }}
              >
                {sentenceSources.map(s => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </select>
            </p>

            {/* 模式切换按钮 */}
            <ModeSwitchButtons
              studyMode={studyMode}
              currentTheme={currentTheme}
              onSwitch={(mode) => {
                stopSentenceLoop();
                setSentenceLoop(false);
                setStudyMode(mode);
              }}
            />

            {/* 搜短句 */}
            <div style={{ marginTop: '15px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: isMobile ? '0 10px' : '0' }}>
              <div style={{ 
                display: 'flex', flexDirection: isMobile ? 'column' : 'row',
                alignItems: 'center', justifyContent: 'center', 
                gap: '10px', width: '100%'
              }}>
                <input
                  type="text"
                  value={sentenceSearchQuery}
                  onChange={e => {
                    setSentenceSearchQuery(e.target.value);
                    if (e.target.value.trim().length > 0) {
                      sentencesAPI.search(e.target.value.trim()).then(data => {
                        setSentenceSearchResults(data.sentences || []);
                        setCurrentSentenceSearchIndex(0);
                      }).catch(() => {});
                    } else {
                      setSentenceSearchResults([]);
                    }
                  }}
                  placeholder="搜短句..."
                  style={{
                    padding: '8px 12px',
                    fontSize: isMobile ? '0.9em' : '1em',
                    border: '2px solid #ddd',
                    borderRadius: '8px',
                    outline: 'none',
                    width: isMobile ? '100%' : '300px',
                    maxWidth: '300px',
                    transition: 'border-color 0.3s',
                  }}
                  onFocus={e => e.target.style.borderColor = '#1890ff'}
                  onBlur={e => e.target.style.borderColor = '#ddd'}
                />
                {sentenceSearchQuery && (
                  <button
                    onClick={() => {
                      if (loopingAudio === 'us' || loopingAudio === 'uk') {
                        if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; }
                        setLoopingAudio(null);
                        setLoopAudioRef(null);
                      }
                      setSentenceSearchQuery('');
                      setSentenceSearchResults([]);
                    }}
                    onMouseEnter={e => e.currentTarget.style.color = '#333'}
                    onMouseLeave={e => e.currentTarget.style.color = '#666'}
                    style={{
                      padding: '8px 12px', background: 'none', border: 'none',
                      cursor: 'pointer', fontSize: isMobile ? '1.2em' : '1.3em',
                      width: isMobile ? '100%' : 'auto',
                      maxWidth: isMobile ? '300px' : 'none',
                      fontWeight: 'bold', color: '#666', transition: 'color 0.2s ease'
                    }}
                  >✕</button>
                )}
              </div>
              {sentenceSearchQuery && (
                <p style={{ fontSize: '0.9em', color: '#666', margin: '5px 0' }}>
                  找到 {sentenceSearchResults.length} 个结果
                </p>
              )}
            </div>

            {/* 句子播放器按钮 */}
            <div style={{ marginTop: '6px', display: 'flex', justifyContent: 'center', width: '100%' }}>
              <button
                className={`wp-trigger-btn${theme === 'dark' ? ' wp-trigger-dark' : ''}`}
                onClick={() => setShowWordPlayer(true)}
                title="打开句子播放器（Ctrl+L）"
              >
                🎵 句子播放器（Ctrl+L）
              </button>
            </div>
          </div>

          {/* 右侧用户区域 */}
          <HeaderUserSection
            isMobile={isMobile}
            theme={theme}
            user={user}
            userProfile={userProfile}
            setCurrentPage={setCurrentPage}
            handleLogout={handleLogout}
            setLoginTab={setLoginTab}
            setShowLoginModal={setShowLoginModal}
            setAuthError={setAuthError}
          />
        </div>

        {/* ===== 句子学习主区域 ===== */}
        <div style={{ textAlign: 'center', padding: '16px', maxWidth: '800px', margin: '0 auto', width: '100%', boxSizing: 'border-box' }}>
          {sentenceSearchQuery ? (
            /* 搜索结果模式 */
            <div>
              {sentenceSearchResults.length === 0 ? (
                <p style={{ textAlign: 'center', color: currentTheme.secondaryText, padding: '40px 0' }}>没有找到相关句子</p>
              ) : (
                <>
                  <p style={{ fontSize: '0.9em', color: currentTheme.secondaryText, margin: '0 0 12px' }}>
                    搜索模式 - 第 {currentSentenceSearchIndex + 1} 个，共 {sentenceSearchResults.length} 个结果
                  </p>
                  {(() => {
                    const s = sentenceSearchResults[currentSentenceSearchIndex];
                    return (
                      <div style={{
                        margin: '0 auto 20px',
                        padding: isMobile ? '20px 16px' : '28px 32px',
                        background: currentTheme.cardBg,
                        borderRadius: '16px',
                        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                      }}>
                        <p style={{ fontSize: isMobile ? '1.1em' : '1.4em', color: currentTheme.text, lineHeight: '1.8', margin: '0 0 12px', fontStyle: 'italic', fontWeight: '500' }}>
                          "{s.sentence_en}"
                        </p>
                        <p style={{ fontSize: '1em', color: currentTheme.secondaryText, margin: '0 0 8px' }}>
                          {s.sentence_cn}
                        </p>
                        <p style={{ fontSize: '0.8em', color: '#bbb', margin: '0 0 12px' }}>
                          {s.source}{s.source_detail ? ` · ${s.source_detail}` : ''}
                        </p>
                        <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                          {s.audio_us && (
                            <button
                              onClick={() => {
                                if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; setLoopingAudio(null); setLoopAudioRef(null); }
                                if (searchExampleAudioRef.current) { searchExampleAudioRef.current.pause(); searchExampleAudioRef.current.onended = null; searchExampleAudioRef.current = null; }
                                if (searchExampleAudioRef2.current) { searchExampleAudioRef2.current.pause(); searchExampleAudioRef2.current = null; }
                                new Audio(`https://www.xiaocixia.cn${s.audio_us}`).play().catch(() => {});
                              }}
                              style={{ padding: '6px 16px', background: 'transparent', color: '#1890ff', border: '1px solid #1890ff', borderRadius: '20px 0 0 20px', cursor: 'pointer', fontSize: '0.85em' }}
                            >🔊 美式</button>
                          )}
                          {s.audio_us && (
                            <button
                              onClick={() => {
                                if (loopingAudio === 'us') {
                                  // 停止循环
                                  if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; }
                                  setLoopingAudio(null);
                                  setLoopAudioRef(null);
                                } else {
                                  // 停止之前的循环
                                  if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; }
                                  // 开始新循环
                                  const audio = new Audio(`https://www.xiaocixia.cn${s.audio_us}`);
                                  const loop = () => { audio.currentTime = 0; audio.play().catch(() => {}); };
                                  audio.addEventListener('ended', loop);
                                  audio.play().catch(() => {});
                                  setLoopingAudio('us');
                                  setLoopAudioRef(audio);
                                }
                              }}
                              style={{
                                padding: '6px 12px',
                                background: loopingAudio === 'us' ? '#1890ff' : 'transparent',
                                color: loopingAudio === 'us' ? 'white' : '#1890ff',
                                border: '1px solid #1890ff',
                                borderRadius: '0 20px 20px 0', cursor: 'pointer', fontSize: '0.85em',
                              }}
                              title={loopingAudio === 'us' ? '停止循环' : '循环播放美式'}
                            >🔁</button>
                          )}
                          {s.audio_uk && (
                            <button
                              onClick={() => {
                                if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; setLoopingAudio(null); setLoopAudioRef(null); }
                                if (searchExampleAudioRef.current) { searchExampleAudioRef.current.pause(); searchExampleAudioRef.current.onended = null; searchExampleAudioRef.current = null; }
                                if (searchExampleAudioRef2.current) { searchExampleAudioRef2.current.pause(); searchExampleAudioRef2.current = null; }
                                new Audio(`https://www.xiaocixia.cn${s.audio_uk}`).play().catch(() => {});
                              }}
                              style={{ padding: '6px 16px', marginLeft: '16px', background: 'transparent', color: '#1890ff', border: '1px solid #1890ff', borderRadius: '20px 0 0 20px', cursor: 'pointer', fontSize: '0.85em' }}
                            >🔊 英式</button>
                          )}
                          {s.audio_uk && (
                            <button
                              onClick={() => {
                                if (loopingAudio === 'uk') {
                                  if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; }
                                  setLoopingAudio(null);
                                  setLoopAudioRef(null);
                                } else {
                                  if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; }
                                  const audio = new Audio(`https://www.xiaocixia.cn${s.audio_uk}`);
                                  const loop = () => { audio.currentTime = 0; audio.play().catch(() => {}); };
                                  audio.addEventListener('ended', loop);
                                  audio.play().catch(() => {});
                                  setLoopingAudio('uk');
                                  setLoopAudioRef(audio);
                                }
                              }}
                              style={{
                                padding: '6px 12px',
                                background: loopingAudio === 'uk' ? '#1890ff' : 'transparent',
                                color: loopingAudio === 'uk' ? 'white' : '#1890ff',
                                border: '1px solid #1890ff',
                                borderRadius: '0 20px 20px 0', cursor: 'pointer', fontSize: '0.85em',
                              }}
                              title={loopingAudio === 'uk' ? '停止循环' : '循环播放英式'}
                            >🔁</button>
                          )}
                          {s.audio_cn && (
                            <button
                              onClick={() => new Audio(resolveAudioFullUrl(s.audio_cn)).play().catch(() => {})}
                              style={{ padding: '6px 16px', marginLeft: '16px', background: 'transparent', color: '#1890ff', border: '1px solid #1890ff', borderRadius: '20px 0 0 20px', cursor: 'pointer', fontSize: '0.85em' }}
                            >🔊 中文</button>
                          )}
                          {s.audio_cn && (
                            <button
                              onClick={() => {
                                if (loopingAudio === 'cn') {
                                  if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; }
                                  setLoopingAudio(null);
                                  setLoopAudioRef(null);
                                } else {
                                  if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; }
                                  const audio = new Audio(resolveAudioFullUrl(s.audio_cn));
                                  const loop = () => { audio.currentTime = 0; audio.play().catch(() => {}); };
                                  audio.addEventListener('ended', loop);
                                  audio.play().catch(() => {});
                                  setLoopingAudio('cn');
                                  setLoopAudioRef(audio);
                                }
                              }}
                              style={{
                                padding: '6px 12px',
                                background: loopingAudio === 'cn' ? '#1890ff' : 'transparent',
                                color: loopingAudio === 'cn' ? 'white' : '#1890ff',
                                border: '1px solid #1890ff',
                                borderRadius: '0 20px 20px 0', cursor: 'pointer', fontSize: '0.85em',
                              }}
                              title={loopingAudio === 'cn' ? '停止循环' : '循环播放中文'}
                            >🔁</button>
                          )}
                        </div>
                      </div>
                    );
                  })()}
                  <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginTop: '16px' }}>
                    <button
                      onClick={() => setCurrentSentenceSearchIndex(prev => Math.max(0, prev - 1))}
                      disabled={currentSentenceSearchIndex === 0}
                      style={{
                        padding: '8px 22px', borderRadius: '6px', cursor: currentSentenceSearchIndex === 0 ? 'not-allowed' : 'pointer',
                        background: 'transparent', border: `1px solid ${currentTheme.border}`,
                        color: currentSentenceSearchIndex === 0 ? '#ccc' : currentTheme.text, fontSize: '0.9em',
                      }}
                    >上一个</button>
                    <button
                      onClick={() => setCurrentSentenceSearchIndex(prev => Math.min(sentenceSearchResults.length - 1, prev + 1))}
                      disabled={currentSentenceSearchIndex === sentenceSearchResults.length - 1}
                      style={{
                        padding: '8px 22px', borderRadius: '6px',
                        cursor: currentSentenceSearchIndex === sentenceSearchResults.length - 1 ? 'not-allowed' : 'pointer',
                        background: '#1890ff', color: 'white', border: 'none', fontSize: '0.9em',
                      }}
                    >下一个</button>
                  </div>
                </>
              )}
            </div>
          ) : isSentencesLoading ? (
            /* 加载中 */
            <div style={{ padding: '60px 20px' }}>
              <p style={{ color: currentTheme.secondaryText }}>加载中...</p>
            </div>
          ) : sentences.length === 0 ? (
            /* 全部削完 */
            <div style={{ padding: '60px 20px' }}>
              <p style={{ fontSize: '2em', margin: '0 0 12px' }}>🎉</p>
              <p style={{ fontSize: '1.3em', color: '#52c41a', margin: '0 0 8px' }}>本分类句子已全部削完！</p>
              <p style={{ color: currentTheme.secondaryText }}>切换其他分类继续学习</p>
            </div>
          ) : (
            /* 正常学习模式 */
            <>
              {/* 句子展示卡片 */}
              <div style={{
                margin: '0 auto 20px',
                padding: isMobile ? '20px 16px' : '28px 32px',
                background: currentTheme.cardBg,
                borderRadius: '16px',
                boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                position: 'relative',
              }}>
                {/* 右上角：循环按钮 + 播放按钮 */}
                <div style={{ position: 'absolute', top: '12px', right: '12px', display: 'flex', gap: '6px', alignItems: 'center' }}>
                  <button
                    onClick={() => playSentenceAudio(sentenceAudioType)}
                    style={{
                      background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.3em',
                      opacity: currentSentence?.audio_us || currentSentence?.audio_uk ? 1 : 0.3,
                    }}
                    title="播放发音"
                  >🔊</button>
                  <button
                    onClick={() => {
                      const newLoop = !sentenceLoop;
                      setSentenceLoop(newLoop);
                      if (newLoop) {
                        playSentenceAudio(sentenceAudioType, true);
                      } else {
                        stopSentenceLoop();
                      }
                    }}
                    style={{
                      background: sentenceLoop ? '#1890ff' : 'none',
                      border: `1px solid ${sentenceLoop ? '#1890ff' : currentTheme.border}`,
                      borderRadius: '4px', cursor: 'pointer', fontSize: '0.75em',
                      padding: '2px 6px',
                      color: sentenceLoop ? 'white' : currentTheme.secondaryText,
                    }}
                    title="循环播放"
                  >🔁</button>
                </div>

                {/* 英文句子(削句模式下隐藏，仅凭发音和中文翻译作答) */}
                <p style={{
                  fontSize: isMobile ? '1.1em' : '1.4em',
                  color: currentTheme.text, lineHeight: '1.8',
                  margin: '0 0 12px', fontStyle: 'italic', fontWeight: '500',
                }}>
                  {isInSentenceMasterMode ? '🔒 请听发音并根据中文翻译输入句子' : `"${currentSentence?.sentence_en}"`}
                </p>

                {/* 中文翻译 */}
                <p style={{ fontSize: '1em', color: currentTheme.secondaryText, margin: '0 0 12px' }}>
                  {currentSentence?.sentence_cn}
                </p>

                {/* 美式/英式/中文按钮 */}
                <div style={{ display: 'flex', justifyContent: 'center', gap: '6px', marginBottom: '8px' }}>
                  {['us', 'uk'].map(type => {
                    const hasAudio = !!getSentenceAudioPath(currentSentence, type);
                    return (
                    <button
                      key={type}
                      disabled={!hasAudio}
                      onClick={() => {
                        setSentenceAudioType(type);
                        const url = getSentenceAudioPath(currentSentence, type);
                        const fullUrl = resolveAudioFullUrl(url);
                        if (fullUrl) {
                          stopSentenceLoop();
                          setSentenceLoop(false);
                          new Audio(fullUrl).play().catch(() => {});
                        }
                      }}
                      style={{
                        padding: '3px 14px', borderRadius: '4px', fontSize: '0.85em',
                        cursor: hasAudio ? 'pointer' : 'not-allowed',
                        opacity: hasAudio ? 1 : 0.4,
                        background: sentenceAudioType === type ? '#1890ff' : currentTheme.cardBg,
                        color: sentenceAudioType === type ? 'white' : currentTheme.text,
                        border: `1px solid ${sentenceAudioType === type ? '#1890ff' : currentTheme.border}`,
                        fontWeight: sentenceAudioType === type ? '600' : '400',
                      }}
                    >
                      {type === 'us' ? '美式' : type === 'uk' ? '英式' : '中文'}
                    </button>
                    );
                  })}
                </div>

                {/* 来源 */}
                {currentSentence?.source_detail && (
                  <p style={{ fontSize: '0.8em', color: '#bbb', margin: 0 }}>
                    — {currentSentence.source_detail}
                  </p>
                )}
              </div>

              {/* 输入框 */}
              <input
                type="text"
                value={sentenceInput}
                onChange={isInSentenceMasterMode ? handleSentenceMasterInput : handleSentenceInput}
                placeholder={isInSentenceMasterMode ? '请输入完整句子' : '输入英文句子...'}
                className={isSentenceInputError ? 'input-incorrect' : ''}
                style={{
                  width: isMobile ? '92%' : '640px',
                  maxWidth: '100%',
                  padding: '12px 16px',
                  fontSize: '1em',
                  border: 'none',
                  borderBottom: `2px solid ${
                    isSentenceInputError ? '#ff4d4f' :
                    isSentenceCorrect ? '#52c41a' :
                    isInSentenceMasterMode ? '#1890ff' : '#3498db'
                  }`,
                  outline: 'none',
                  background: currentTheme.background,
                  color: currentTheme.text,
                  textAlign: 'center',
                  marginBottom: '16px',
                  borderRadius: '0',
                  boxSizing: 'border-box',
                }}
                autoFocus
              />

              {/* 自动播放 + 音效 */}
              <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginBottom: '16px', flexWrap: 'wrap' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer', fontSize: '0.85em', color: currentTheme.text }}>
                  <input
                    type="checkbox"
                    checked={autoPlayAudio}
                    onChange={e => {
                      const checked = e.target.checked;
                      setAutoPlayAudio(checked);
                      if (checked && currentSentence) {
                        const url = getSentenceAudioPath(currentSentence, sentenceAudioType);
                        const fullUrl = resolveAudioFullUrl(url);
                        if (fullUrl) {
                          new Audio(fullUrl).play().catch(() => {});
                        }
                      }
                    }}
                  />
                  自动播放发音
                </label>
                {/* <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer', fontSize: '0.85em', color: currentTheme.text }}>
                  <input
                    type="checkbox"
                    checked={keyboardSound}
                    onChange={e => setKeyboardSound(e.target.checked)}
                  />
                  开启音效
                </label> */}
              </div>

              {/* 操作按钮 */}
              <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', flexWrap: 'wrap', marginBottom: '20px' }}>
                <button
                  onClick={() => {
                    if (isInSentenceMasterMode) return;
                    stopSentenceLoop();
                    setSentenceLoop(false);
                    const next = (currentSentenceIndex + 1) % sentences.length;
                    setCurrentSentenceIndex(next);
                    setSentenceInput('');
                    setIsInSentenceMasterMode(false);
                    if (autoPlayAudio) {
                      const s = sentences[next];
                      const url = getSentenceAudioPath(s, sentenceAudioType);
                      const fullUrl = resolveAudioFullUrl(url);
                      if (fullUrl) {
                        setTimeout(() => new Audio(fullUrl).play().catch(() => {}), 100);
                      }
                    }
                  }}
                  disabled={isInSentenceMasterMode}
                  style={{
                    padding: '8px 22px', borderRadius: '6px',
                    cursor: isInSentenceMasterMode ? 'not-allowed' : 'pointer',
                    fontSize: '0.9em',
                    background: isInSentenceMasterMode ? '#d9d9d9' : 'transparent',
                    border: `1px solid ${isInSentenceMasterMode ? '#d9d9d9' : currentTheme.border}`,
                    color: isInSentenceMasterMode ? '#999' : currentTheme.text,
                  }}
                >{isInSentenceMasterMode ? '连续削句中...' : '跳过'}</button>

                {!isInSentenceMasterMode && (
                  <button
                    onClick={() => {
                      if (!user) return;
                      setIsInSentenceMasterMode(true);
                      setSentenceInput('');
                      setAutoPlayAudio(true);
                      if (currentSentence) {
                        const url = getSentenceAudioPath(currentSentence, sentenceAudioType);
                        const fullUrl = resolveAudioFullUrl(url);
                        if (fullUrl) {
                          new Audio(fullUrl).play().catch(() => {});
                        }
                      }
                      // if (keyboardSound) playSwordSound('open02.wav'); // 句子页暂不启用音效功能
                    }}
                    disabled={!user}
                    style={{
                      padding: '8px 22px', borderRadius: '6px',
                      cursor: user ? 'pointer' : 'not-allowed',
                      fontSize: '0.9em',
                      background: user ? '#1890ff' : '#d9d9d9',
                      color: user ? 'white' : '#999',
                      border: 'none',
                    }}
                  >{user ? '进入削句模式' : '登录后可削句'}</button>
                )}

                {isInSentenceMasterMode && (
                  <button
                    onClick={() => { setIsInSentenceMasterMode(false); setSentenceInput(''); }}
                    style={{
                      padding: '8px 22px', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9em',
                      background: '#ff4d4f', color: 'white', border: 'none',
                    }}
                  >退出削句模式</button>
                )}
              </div>
            </>
          )}
        </div>

        {/* ===== 进度条（样式与学单词页面保持一致）===== */}
        <ProgressBars
          isMobile={isMobile}
          bar1Label="学习进度"
          bar1Current={unmasteredCount}
          bar1Total={totalSentencesInSource}
          bar1Percent={studyProgressPercent}
          bar2Label="削句进度"
          bar2Current={masteredCount}
          bar2Total={totalSentencesInSource}
          bar2Percent={masterProgressPercent}
        />

        {/* ===== 底部（完全复用学单词）===== */}
        <footer style={footerStyle}>
        <div style={footerLinksStyle}>
          <button onClick={() => setCurrentPage('about')} style={{ background: 'none', border: 'none', color: '#1890ff', cursor: 'pointer', fontSize: '1em', padding: '5px' }}>关于我们</button>
          <button onClick={() => setCurrentPage('contact')} style={{ background: 'none', border: 'none', color: '#1890ff', cursor: 'pointer', fontSize: '1em', padding: '5px' }}>联系我们</button>
          <button onClick={() => setCurrentPage('faq')} style={{ background: 'none', border: 'none', color: '#1890ff', cursor: 'pointer', fontSize: '1em', padding: '5px' }}>常见问题</button>
          <button onClick={() => setCurrentPage('privacy')} style={{ background: 'none', border: 'none', color: '#1890ff', cursor: 'pointer', fontSize: '1em', padding: '5px' }}>隐私政策</button>
        </div>
        <p style={{ 
          margin: '10px 0', 
          color: '#999', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          flexWrap: 'wrap',
          gap: '5px'  // 添加统一间距
        }}>
          <span>© 2025 削词侠 XIAOCIXIA.CN All rights reserved.</span>
          <span>|</span>
          <a 
            href="https://beian.mps.gov.cn/#/query/webSearch?code=44196902000117"
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              color: '#999', 
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center'
            }}
          >
            <img 
              src="/images/filing-icon.png" 
              alt="公安备案图标" 
              style={{ 
                width: '16px', 
                height: '16px', 
                marginRight: '4px'
              }}
            />
            粤公网安备44196902000117号
          </a>
          <span>|</span>
          <a 
            href="https://beian.miit.gov.cn/" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: '#999', textDecoration: 'none' }}
          >
            粤ICP备20054820号
          </a>
        </p>
      </footer>

        {/* 登录弹窗（与学单词页面共用同一组件） */}
        <LoginModal
          showLoginModal={showLoginModal}
          setShowLoginModal={setShowLoginModal}
          theme={theme}
          isMobile={isMobile}
          isHovering={isHovering}
          loginTab={loginTab}
          setLoginTab={setLoginTab}
          authError={authError}
          setAuthError={setAuthError}
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          emailInputRef={emailInputRef}
          passwordInputRef={passwordInputRef}
          handleLoginFocus={handleLoginFocus}
          handleLogin={handleLogin}
          handleRegister={handleRegister}
          handleResetPassword={handleResetPassword}
          apiBase={API_BASE_URL}
        />

        {/* 句子播放器弹窗（学句子页面之前缺失，导致点击按钮没反应；这里默认直接以句子模式打开） */}
        <WordPlayer
          isOpen={showWordPlayer}
          onClose={() => setShowWordPlayer(false)}
          words={words}
          filteredWords={filteredWords}
          category={category}
          categories={categories}
          theme={theme}
          sentenceSources={sentenceSources}
          defaultSentenceSource={currentSource}
          initialContentType="sentence"
        />

        {/* 小程序二维码悬浮按钮 */}
        <QRCodeFloatButton
          greenScreen={greenScreen}
          theme={theme}
          showQRCode={showQRCode}
          setShowQRCode={setShowQRCode}
        />
      </div>
    );
  }

  // 主页面渲染
  return (
  <>
    {/* ✅ 添加动画样式 */}
    <style>{`
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(-360deg); }
      }
      
      @keyframes spinDown {
        0% { 
          transform: rotate(0deg);
          animation-timing-function: ease-out;
        }
        100% { 
          transform: rotate(-360deg);
        }
      }
      
      @keyframes slashAnim {
        0% { width: 0; opacity: 1; }
        60% { width: 80vw; opacity: 1; }
        100% { width: 80vw; opacity: 0; }
      }
      @keyframes wordTopFly {
        0% { transform: translateY(0); opacity: 1; }
        20% { opacity: 1; }
        100% { transform: translateY(-120vh); opacity: 0; }
      }
      @keyframes wordBottomFall {
        0% { transform: translateY(0); opacity: 1; }
        20% { opacity: 1; }
        100% { transform: translateY(120vh); opacity: 0; }
      }
      @keyframes firework {
        0% { transform: scale(0); opacity: 1; }
        50% { opacity: 1; }
        100% { transform: scale(8) translate(var(--tx, 20px), var(--ty, -30px)); opacity: 0; }
      }

      @keyframes fadeInUp {
        0% { opacity: 0; transform: translateY(10px); }
        100% { opacity: 1; transform: translateY(0); }
      }
      
      /* 绿屏模式覆盖样式 */
      .green-screen-mode * {
        color: #ffffff !important;
        border-color: rgba(255,255,255,0.5) !important;
        background-color: transparent !important;
        text-shadow: 
          2px 2px 4px rgba(0,0,0,1),
          -2px -2px 4px rgba(0,0,0,1),
          2px -2px 4px rgba(0,0,0,1),
          -2px 2px 4px rgba(0,0,0,1),
          0 0 10px rgba(0,0,0,0.9) !important;
        font-weight: 700 !important;
      }
      .green-screen-mode p,
      .green-screen-mode span,
      .green-screen-mode label {
        font-size: 1.1em !important;
      }
      .green-screen-mode input {
        background: transparent !important;
        color: #ffffff !important;
        border-bottom-color: rgba(255,255,255,0.8) !important;
      }
      .green-screen-mode input::placeholder {
        color: rgba(255,255,255,0.8) !important;
        text-shadow: 
          1px 1px 3px rgba(0,0,0,0.9),
          0 0 8px rgba(0,0,0,0.8) !important;
      }
      .green-screen-mode select {
        background: transparent !important;
        color: #ffffff !important;
      }
      .green-screen-mode button {
        background: rgba(0,0,0,0.3) !important;
        color: #ffffff !important;
        border: 1px solid rgba(255,255,255,0.4) !important;
      }
      .green-screen-mode .custom-progress::-webkit-progress-bar {
        background: rgba(255,255,255,0.2) !important;
      }
      .green-screen-mode .custom-progress::-webkit-progress-value {
        background: rgba(255,255,255,0.9) !important;
      }
    `}</style>

    {/* 单词分裂动画 */}
    {wordSplitAnim && wordRect && (() => {
      const rect = wordRect;
      const centerY = rect.top + rect.height / 2;
      const wordFontSize = isMobile ? '2em' : '3em';

      return (
        <>
          {/* 剑光横划 */}
          <div style={{
            position: 'fixed',
            top: `${centerY}px`,
            left: 0,
            right: 0,
            zIndex: 9000,
            pointerEvents: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transform: 'translateY(-50%)',
          }}>
            <div style={{
              height: '3px',
              background: 'linear-gradient(90deg, transparent, #fff, #60cfff, #fff, transparent)',
              boxShadow: '0 0 12px 4px #60cfff, 0 0 24px 8px rgba(96,207,255,0.4)',
              animation: 'slashAnim 0.35s ease-out forwards',
              width: '0',
            }} />
          </div>

          {/* 单词上半部分 - 向上飞出 */}
          <div style={{
            position: 'fixed',
            top: `${rect.top}px`,
            left: `${rect.left}px`,
            width: `${rect.width}px`,
            height: `${rect.height / 2}px`,
            overflow: 'hidden',
            zIndex: 8999,
            pointerEvents: 'none',
            animation: 'wordTopFly 0.9s ease-in forwards',
            animationDelay: '0.25s',
            opacity: 0,
          }}>
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              fontSize: wordFontSize,
              fontWeight: 'bold',
              color: greenScreen ? '#ffffff' : currentTheme.text,
              whiteSpace: 'nowrap',
              letterSpacing: '0.05em',
              lineHeight: `${rect.height}px`,
              textAlign: 'center',
              textShadow: greenScreen ? '2px 2px 4px rgba(0,0,0,1), -2px -2px 4px rgba(0,0,0,1), 2px -2px 4px rgba(0,0,0,1), -2px 2px 4px rgba(0,0,0,1)' : 'none',
            }}>
              {splitWord}
            </div>
          </div>

          {/* 单词下半部分 - 向下掉落 */}
          <div style={{
            position: 'fixed',
            top: `${rect.top + rect.height / 2}px`,
            left: `${rect.left}px`,
            width: `${rect.width}px`,
            height: `${rect.height / 2}px`,
            overflow: 'hidden',
            zIndex: 8999,
            pointerEvents: 'none',
            animation: 'wordBottomFall 0.9s ease-in forwards',
            animationDelay: '0.25s',
            opacity: 0,
          }}>
            <div style={{
              position: 'absolute',
              top: `-${rect.height / 2}px`,
              left: 0,
              width: '100%',
              fontSize: wordFontSize,
              fontWeight: 'bold',
              color: greenScreen ? '#ffffff' : currentTheme.text,
              whiteSpace: 'nowrap',
              letterSpacing: '0.05em',
              lineHeight: `${rect.height}px`,
              textAlign: 'center',
              textShadow: greenScreen ? '2px 2px 4px rgba(0,0,0,1), -2px -2px 4px rgba(0,0,0,1), 2px -2px 4px rgba(0,0,0,1), -2px 2px 4px rgba(0,0,0,1)' : 'none',
            }}>
              {splitWord}
            </div>
          </div>
        </>
      );
    })()}

    {/* 烟花效果 */}
    {showFireworks && (
      <div style={{
        position: 'fixed',
        inset: 0,
        zIndex: 8888,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}>
        {[...Array(30)].map((_, i) => {
          const tx = (Math.random() - 0.5) * 300;
          const ty = (Math.random() - 0.5) * 300;
          return (
            <div key={i} style={{
              position: 'absolute',
              left: `${10 + Math.random() * 80}%`,
              top: `${10 + Math.random() * 80}%`,
              width: `${6 + Math.random() * 8}px`,
              height: `${6 + Math.random() * 8}px`,
              borderRadius: '50%',
              background: `hsl(${Math.floor(Math.random() * 360)}, 100%, 60%)`,
              '--tx': `${tx}px`,
              '--ty': `${ty}px`,
              animation: `firework ${0.8 + Math.random() * 0.8}s ease-out ${Math.random() * 1.5}s forwards`,
              opacity: 0,
            }} />
          );
        })}
      </div>
    )}

    {/* 广告弹窗 */}
    {showAdModal && (
      <div
        onClick={() => setShowAdModal(false)}
        style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
        }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: 'relative',
            // maxWidth: isMobile ? '90vw' : '500px',
            maxWidth: isMobile ? '95vw' : '768px',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
          }}
        >
          {/* 关闭按钮 */}
          <button
            onClick={() => setShowAdModal(false)}
            style={{
              position: 'absolute',
              top: '10px', right: '10px',
              background: 'rgba(0,0,0,0.5)',
              color: 'white',
              border: 'none',
              borderRadius: '50%',
              width: '30px', height: '30px',
              fontSize: '1em',
              cursor: 'pointer',
              zIndex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            ✕
          </button>

          {/* 广告图片，点击跳转 */}
          <a
            href="https://shutterlocation.cn/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setShowAdModal(false)}
          >
            <img
              src={currentAdImage || '/images/ads/ad1.jpg'}
              alt="广告"
              style={{
                width: '100%',
                maxWidth: '1536px',
                display: 'block',
                cursor: 'pointer',
              }}
            />
          </a>

          {/* 底部提示 */}
          <div style={{
            background: 'rgba(0,0,0,0.7)',
            color: '#aaa',
            fontSize: '0.75em',
            textAlign: 'center',
            padding: '6px',
          }}>
            广告 · 点击图片访问 · 点击其他区域关闭
          </div>
        </div>
      </div>
    )}

    <div style={containerStyle} className={greenScreen ? 'green-screen-mode' : ''}>
      {error && !error.includes('无') && !error.includes('发音') && (
        <p style={{ 
          color: currentTheme.errorText, 
          padding: '10px', 
          background: currentTheme.errorBg, 
          textAlign: 'center',
          borderRadius: '4px',
        }}>
          {error}
        </p>
      )}
      <div style={headerStyle}>
        <HeaderTitleSection
          isMobile={isMobile}
          currentTheme={currentTheme}
          isHovering={isHovering}
          setIsHovering={setIsHovering}
          theme={theme}
          toggleTheme={toggleTheme}
          greenScreen={greenScreen}
          setGreenScreen={setGreenScreen}
          setShowQRCode={setShowQRCode}
        />
        <div style={centerSectionStyle}>
          <p style={{ 
            fontSize: isMobile ? '1em' : '1.2em', 
            margin: '0 0 10px 0', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: '5px'
          }}>
            当前级别:
            <select
              value={category}
              onChange={handleCategoryChange}
              onMouseDown={handleSelectEvent}
              onMouseUp={handleSelectEvent}
              onTouchStart={handleSelectEvent}
              onFocus={handleSelectEvent}
              onBlur={handleSelectEvent}
              disabled={words.length === 0 && error}
              style={{
                marginLeft: isMobile ? '0' : '10px',
                marginTop: isMobile ? '5px' : '0',
                padding: '5px',
                fontSize: isMobile ? '0.9em' : '1em',
                border: 'none',
                borderBottom: `2px solid ${currentTheme.border}`,
                borderRadius: '0',
                background: currentTheme.background,
                color: currentTheme.text,
                outline: 'none',
                width: 'auto',
                maxWidth: isMobile ? '250px' : 'none',
                textAlign: 'center',
                opacity: words.length === 0 && error ? 0.5 : 1,
              }}
            >
              {categories.map((cat) => (
                <option key={cat.value} value={cat.value}>
                  {cat.label}
                  {user ? ` 已完成 ${completedCounts[cat.value] || 0} 次学习` : ''}
                </option>
              ))}
            </select>
          </p>

          {/* 学习模式切换 */}
          <ModeSwitchButtons
            studyMode={studyMode}
            currentTheme={currentTheme}
            onSwitch={(mode) => {
              stopWordAudioLoops();
              setStudyMode(mode);
            }}
          />

          {studyMode === 'usage' && (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '8px',
              marginTop: '8px',
            }}>
              <span style={{ fontSize: '0.8em', color: currentTheme.text }}>例句停留:</span>
              {[0.75, 1, 1.5, 2].map(speed => (
                <button
                  key={speed}
                  onClick={() => {
                    setExampleSpeedMultiplier(speed);
                    localStorage.setItem('exampleSpeedMultiplier', speed.toString());
                  }}
                  style={{
                    padding: '3px 10px',
                    borderRadius: '12px',
                    border: exampleSpeedMultiplier === speed ? 'none' : `1px solid ${currentTheme.border}`,
                    background: exampleSpeedMultiplier === speed ? '#1890ff' : 'transparent',
                    color: exampleSpeedMultiplier === speed ? 'white' : currentTheme.text,
                    fontSize: '0.75em',
                    cursor: 'pointer',
                  }}
                >
                  {speed}x
                </button>
              ))}
            </div>
          )}
          
          {/* 搜索框 */}
          <div style={{ marginTop: '15px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: isMobile ? '0 10px' : '0' }}>
            <div style={{ 
              display: 'flex', 
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: 'center', 
              justifyContent: 'center', 
              gap: '10px',
              width: '100%'
            }}>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => handleSearch(e.target.value)}
                placeholder="搜单词..."
                style={{
                  padding: '8px 12px',
                  fontSize: isMobile ? '0.9em' : '1em',
                  border: '2px solid #ddd',
                  borderRadius: '8px',
                  outline: 'none',
                  width: isMobile ? '100%' : '300px',
                  maxWidth: '300px',
                  transition: 'border-color 0.3s',
                }}
                onFocus={(e) => e.target.style.borderColor = '#1890ff'}
                onBlur={(e) => e.target.style.borderColor = '#ddd'}
              />
              {uiState.searchMode && (
                <button
                  onClick={exitSearchMode}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#333'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#666'}
                  style={{
                    padding: '8px 12px',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: isMobile ? '1.2em' : '1.3em',
                    width: isMobile ? '100%' : 'auto',
                    maxWidth: isMobile ? '300px' : 'none',
                    fontWeight: 'bold',
                    color: '#666',
                    transition: 'color 0.2s ease'
                  }}
                >
                  ✕
                </button>
              )}
            </div>
            {uiState.searchMode && (
              <p style={{ fontSize: '0.9em', color: '#666', margin: '5px 0' }}>
                找到 {searchResults.length} 个结果
              </p>
            )}

            {/* 单词播放器触发按钮 */}
            <div style={{ marginTop: '6px', display: 'flex', justifyContent: 'center', width: '100%' }}>
              <button
                className={`wp-trigger-btn${theme === 'dark' ? ' wp-trigger-dark' : ''}`}
                onClick={() => setShowWordPlayer(true)}
                title="打开单词播放器（Ctrl+L）"
              >
                🎵 单词播放器（Ctrl+L）
              </button>
            </div>
          </div>
        </div>

        <HeaderUserSection
          isMobile={isMobile}
          theme={theme}
          user={user}
          userProfile={userProfile}
          setCurrentPage={setCurrentPage}
          handleLogout={handleLogout}
          setLoginTab={setLoginTab}
          setShowLoginModal={setShowLoginModal}
          setAuthError={setAuthError}
        />
      </div>
      {words.length === 0 && !error && <p style={{ textAlign: 'center' }}>加载中...</p>}
      {words.length === 0 && error && (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <p style={{ color: 'red', fontSize: '1.2em' }}>
            {error}
            <br />
            请检查 public 文件夹中的 words.json 是否存在，或尝试刷新页面。
          </p>
        </div>
      )}
      {words.length > 0 && (
        <div style={{ textAlign: 'center' }}>
          {/* 搜索模式 */}
          {uiState.searchMode ? (
            searchResults.length === 0 ? (
              <p style={{ color: '#666', padding: '20px', fontSize: '1.2em' }}>
                未找到包含 &quot;{searchQuery}&quot; 的单词
              </p>
            ) : (
              <>
                <div style={{ margin: '10px 0', color: '#666' }}>
                  <p>搜索模式 - 第 {currentWordIndex + 1} 个，共 {searchResults.length} 个结果</p>
                </div>
                <h3
                  style={wordDisplayStyle}
                  className={uiState.isIncorrectWord ? 'word-incorrect' : ''}
                >
                  {currentWord.word || '无单词'}
                </h3>
                
                {/* 发音切换按钮 - 只保留一组 */}
                <div style={{ marginBottom: '10px' }}>
                  <button
                    onClick={() => {
                      // 先停止当前播放
                      if (audioRef.current) {
                        audioRef.current.pause();
                        audioRef.current.src = '';
                        audioRef.current = null;
                      }
                      
                      setPronunciationType('us');
                      
                      // 播放搜索结果的发音
                      const wordToPlay = searchResults[currentWordIndex];
                      if (wordToPlay?.audio?.us && wordToPlay.audio.us !== '') {
                        setTimeout(() => playAudio(wordToPlay.audio.us, wordToPlay.word, false), 100);
                      }
                    }}
                    style={{
                      padding: '5px 15px',
                      background: pronunciationType === 'us' ? '#1890ff' : '#f0f0f0',
                      color: pronunciationType === 'us' ? 'white' : '#666',
                      border: `1px solid ${theme === 'dark' ? '#555' : '#ddd'}`,
                      borderRadius: '4px 0 0 4px',
                      cursor: 'pointer',
                      fontSize: '0.9em',
                    }}
                  >
                    美式
                  </button>
                  <button
                    onClick={() => {
                      // 先停止当前播放
                      if (audioRef.current) {
                        audioRef.current.pause();
                        audioRef.current.src = '';
                        audioRef.current = null;
                      }
                      
                      setPronunciationType('uk');
                      
                      // 播放搜索结果的发音
                      const wordToPlay = searchResults[currentWordIndex];
                      if (wordToPlay?.audio?.uk && wordToPlay.audio.uk !== '') {
                        setTimeout(() => playAudio(wordToPlay.audio.uk, wordToPlay.word, false), 100);
                      }
                    }}
                    style={{
                      padding: '5px 15px',
                      background: pronunciationType === 'uk' ? '#1890ff' : '#f0f0f0',
                      color: pronunciationType === 'uk' ? 'white' : '#666',
                      border: `1px solid ${theme === 'dark' ? '#555' : '#ddd'}`,
                      borderRadius: '0 4px 4px 0',
                      cursor: 'pointer',
                      fontSize: '0.9em',
                    }}
                  >
                    英式
                  </button>
                </div>

                <p style={{ fontSize: '1.2em', display: 'inline-flex', alignItems: 'center' }}>
                  音标: {currentWord.phonetic?.[pronunciationType] || '无'}
                  {currentWord.audio?.[pronunciationType] && currentWord.audio[pronunciationType] !== '' ? (
                    <>
                      <button
                        aria-label="播放发音"
                        onClick={() => playAudio(currentWord.audio[pronunciationType], currentWord.word, false)}
                        onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(2px)'}
                        onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        style={{
                          marginLeft: '20px',
                          position: 'relative',
                          top: '3px',
                          fontSize: '0.8em',
                          cursor: 'pointer',
                          padding: '2px',
                          lineHeight: '1',
                          background: 'none',
                          border: 'none',
                          display: 'inline-flex',
                          alignItems: 'center',
                          transition: 'transform 0.1s ease',
                        }}
                        title="单次播放"
                      >
                        🔊
                      </button>
                      <button
                        aria-label={loopPlay ? '停止循环播放' : '循环播放'}
                        onClick={toggleLoopPlay}
                        onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(2px)'}
                        onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        style={{
                          marginLeft: '5px',
                          position: 'relative',
                          top: '3px',
                          fontSize: '0.8em',
                          cursor: 'pointer',
                          padding: '2px',
                          lineHeight: '1',
                          color: loopPlay ? 'blue' : 'black',
                          background: 'none',
                          border: 'none',
                          display: 'inline-flex',
                          alignItems: 'center',
                          transition: 'transform 0.1s ease',
                        }}
                        title={loopPlay ? '停止循环' : '循环播放'}
                      >
                        {loopPlay ? '⏸️' : '🔁'}  {/* ✅ 修改：循环播放时显示暂停图标 */}
                      </button>
                    </>
                  ) : (
                    <span style={{ fontSize: '0.8em', color: 'red', marginLeft: '20px' }}>无发音</span>
                  )}
                </p>
                <p style={{ fontSize: '1.2em' }}>中文释义: {currentWord.meaning_cn || '无'}</p>
                {currentWord.example_en && (uiState.searchMode || (studyMode === 'usage' && showExampleAfterCorrect)) && (
                  <div 
                    onClick={() => {
                      if (uiState.searchMode) return;
                      toggleExamplePause();
                    }}
                    style={{
                      cursor: uiState.searchMode ? 'default' : 'pointer',
                    margin: '16px auto',
                    padding: '16px 24px',
                    background: theme === 'dark' ? 'rgba(255,255,255,0.05)' : '#f8f9fa',
                    border: theme === 'dark' ? '1px solid rgba(255,255,255,0.1)' : '1px solid #e8e8e8',
                    borderRadius: '12px',
                    textAlign: 'center',
                    maxWidth: '600px',
                  }}>
                    <p style={{ 
                      fontSize: '1.1em', 
                      color: theme === 'dark' ? '#ddd' : '#444',
                      margin: '0 0 8px',
                      fontStyle: 'italic',
                      lineHeight: '1.6',
                    }}>
                      "{currentWord.example_en}"
                    </p>
                    <p style={{ 
                      fontSize: '0.95em', 
                      color: theme === 'dark' ? '#999' : '#999',
                      margin: '0 0 8px',
                    }}>
                      {currentWord.example_cn}
                    </p>
                    {studyMode === 'usage' && (
                      <div onClick={(e) => e.stopPropagation()} style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '4px' }}>
                        {isExamplePaused ? (
                          <>
                            <span style={{ fontSize: '0.8em', color: '#999', alignSelf: 'center' }}>⏸ 已暂停</span>
                            <button
                              onClick={() => replayExampleAudio(currentWord)}
                              style={{
                                padding: '4px 12px', fontSize: '0.8em', borderRadius: '16px',
                                border: '1px solid #1890ff', background: 'transparent',
                                color: '#1890ff', cursor: 'pointer',
                              }}
                            >
                              🔁 重播
                            </button>
                            <button
                              onClick={() => toggleExampleLoop(currentWord)}
                              style={{
                                padding: '4px 12px', fontSize: '0.8em', borderRadius: '16px',
                                border: '1px solid #1890ff',
                                background: isExampleLooping ? '#1890ff' : 'transparent',
                                color: isExampleLooping ? 'white' : '#1890ff',
                                cursor: 'pointer',
                              }}
                            >
                              🔂 循环
                            </button>
                            <button
                              onClick={toggleExamplePause}
                              style={{
                                padding: '4px 12px', fontSize: '0.8em', borderRadius: '16px',
                                border: '1px solid #52c41a', background: 'transparent',
                                color: '#52c41a', cursor: 'pointer',
                              }}
                            >
                              ▶ 继续
                            </button>
                          </>
                        ) : (
                          <span 
                            onClick={toggleExamplePause}
                            style={{ fontSize: '0.75em', color: '#bbb', cursor: 'pointer' }}
                          >
                            点击暂停
                          </span>
                        )}
                      </div>
                    )}
                    
                    <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginTop: '10px' }}>
                    {/* 美式组 */}
                    <div style={{ display: 'flex', marginRight: '16px' }}>
                      <button
                        onClick={() => {
                          if (searchExampleAudioRef.current) { searchExampleAudioRef.current.pause(); searchExampleAudioRef.current.onended = null; searchExampleAudioRef.current = null; }
                          if (searchExampleAudioRef2.current) { searchExampleAudioRef2.current.pause(); searchExampleAudioRef2.current = null; }
                          if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; setLoopingAudio(null); setLoopAudioRef(null); }
                          const url = searchResults[currentWordIndex]?.example_audio_us;
                          if (!url) return;
                          const fullUrl = url.startsWith('http') ? url : `https://www.xiaocixia.cn${url}`;
                          const audio = new Audio(fullUrl);
                          audio.play().catch(() => {});
                          searchExampleAudioRef2.current = audio;
                        }}
                        style={{
                          padding: '6px 16px',
                          background: 'transparent', color: '#1890ff',
                          border: '1px solid #1890ff',
                          borderRadius: '20px 0 0 20px',
                          cursor: 'pointer', fontSize: '0.85em',
                          display: 'flex', alignItems: 'center', gap: '4px',
                        }}
                      >🔊 美式</button>
                      <button
                        onClick={() => {
                          if (loopingAudio === 'ex_us') {
                            if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; }
                            setLoopingAudio(null);
                            setLoopAudioRef(null);
                          } else {
                            if (searchExampleAudioRef.current) { searchExampleAudioRef.current.pause(); searchExampleAudioRef.current.onended = null; searchExampleAudioRef.current = null; }
                            if (searchExampleAudioRef2.current) { searchExampleAudioRef2.current.pause(); searchExampleAudioRef2.current = null; }
                            if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; }
                            const url = searchResults[currentWordIndex]?.example_audio_us;
                            if (!url) return;
                            const fullUrl = url.startsWith('http') ? url : `https://www.xiaocixia.cn${url}`;
                            const audio = new Audio(fullUrl);
                            const loop = () => { audio.currentTime = 0; audio.play().catch(() => {}); };
                            audio.addEventListener('ended', loop);
                            audio.play().catch(() => {});
                            setLoopingAudio('ex_us');
                            setLoopAudioRef(audio);
                          }
                        }}
                        style={{
                          padding: '6px 12px',
                          background: loopingAudio === 'ex_us' ? '#1890ff' : 'transparent',
                          color: loopingAudio === 'ex_us' ? 'white' : '#1890ff',
                          border: '1px solid #1890ff',
                          borderRadius: '0 20px 20px 0',
                          cursor: 'pointer', fontSize: '0.85em',
                          display: 'flex', alignItems: 'center',
                        }}
                        title={loopingAudio === 'ex_us' ? '停止循环' : '循环播放美式'}
                      >🔁</button>
                    </div>

                    {/* 英式组 */}
                    <div style={{ display: 'flex' }}>
                      <button
                        onClick={() => {
                          if (searchExampleAudioRef.current) { searchExampleAudioRef.current.pause(); searchExampleAudioRef.current.onended = null; searchExampleAudioRef.current = null; }
                          if (searchExampleAudioRef2.current) { searchExampleAudioRef2.current.pause(); searchExampleAudioRef2.current = null; }
                          if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; setLoopingAudio(null); setLoopAudioRef(null); }
                          const url = searchResults[currentWordIndex]?.example_audio_uk;
                          if (!url) return;
                          const fullUrl = url.startsWith('http') ? url : `https://www.xiaocixia.cn${url}`;
                          const audio = new Audio(fullUrl);
                          audio.play().catch(() => {});
                          searchExampleAudioRef2.current = audio;
                        }}
                        style={{
                          padding: '6px 16px',
                          background: 'transparent', color: '#1890ff',
                          border: '1px solid #1890ff',
                          borderRadius: '20px 0 0 20px',
                          cursor: 'pointer', fontSize: '0.85em',
                          display: 'flex', alignItems: 'center', gap: '4px',
                        }}
                      >🔊 英式</button>
                      <button
                        onClick={() => {
                          if (loopingAudio === 'ex_uk') {
                            if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; }
                            setLoopingAudio(null);
                            setLoopAudioRef(null);
                          } else {
                            if (searchExampleAudioRef.current) { searchExampleAudioRef.current.pause(); searchExampleAudioRef.current.onended = null; searchExampleAudioRef.current = null; }
                            if (searchExampleAudioRef2.current) { searchExampleAudioRef2.current.pause(); searchExampleAudioRef2.current = null; }
                            if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; }
                            const url = searchResults[currentWordIndex]?.example_audio_uk;
                            if (!url) return;
                            const fullUrl = url.startsWith('http') ? url : `https://www.xiaocixia.cn${url}`;
                            const audio = new Audio(fullUrl);
                            const loop = () => { audio.currentTime = 0; audio.play().catch(() => {}); };
                            audio.addEventListener('ended', loop);
                            audio.play().catch(() => {});
                            setLoopingAudio('ex_uk');
                            setLoopAudioRef(audio);
                          }
                        }}
                        style={{
                          padding: '6px 12px',
                          background: loopingAudio === 'ex_uk' ? '#1890ff' : 'transparent',
                          color: loopingAudio === 'ex_uk' ? 'white' : '#1890ff',
                          border: '1px solid #1890ff',
                          borderRadius: '0 20px 20px 0',
                          cursor: 'pointer', fontSize: '0.85em',
                          display: 'flex', alignItems: 'center',
                        }}
                        title={loopingAudio === 'ex_uk' ? '停止循环' : '循环播放英式'}
                      >🔁</button>
                    </div>
                  </div>
                  </div>
                )}
                <p style={{ fontSize: '1em', color: '#666' }}>
                  类别: {Array.isArray(currentWord.category) ? currentWord.category.join(', ') : currentWord.category || '未分类'}
                </p>
                
                <div style={{ margin: '20px 0', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                  <button
                    onClick={() => {
                      // 停止当前播放
                      if (audioRef.current) {
                        audioRef.current.pause();
                        audioRef.current.src = '';
                        audioRef.current = null;
                      }
                      setCurrentWordIndex(Math.max(0, currentWordIndex - 1));
                    }}
                    disabled={currentWordIndex === 0}
                    style={{
                      padding: '8px 16px',
                      background: currentWordIndex === 0 ? '#f0f0f0' : '#1890ff',
                      color: currentWordIndex === 0 ? '#999' : 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: currentWordIndex === 0 ? 'not-allowed' : 'pointer',
                    }}
                  >
                    上一个
                  </button>
                  <button
                    onClick={() => {
                      // 停止当前播放
                      if (audioRef.current) {
                        audioRef.current.pause();
                        audioRef.current.src = '';
                        audioRef.current = null;
                      }
                      setCurrentWordIndex(Math.min(searchResults.length - 1, currentWordIndex + 1));
                    }}
                    disabled={currentWordIndex === searchResults.length - 1}
                    style={{
                      padding: '8px 16px',
                      background: currentWordIndex === searchResults.length - 1 ? '#f0f0f0' : '#1890ff',
                      color: currentWordIndex === searchResults.length - 1 ? '#999' : 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: currentWordIndex === searchResults.length - 1 ? 'not-allowed' : 'pointer',
                    }}
                  >
                    下一个
                  </button>
                </div>
              </>
            )
          ) : (
            /* 学习模式 */
            filteredWords.length === 0 && 
            Object.keys(dailyProgress).length > 0 && 
            isDataLoaded && 
            user ? (
              <div style={{ textAlign: 'center' }}>
                <FireworksOnMount
                  onMount={() => {
                    if (!showFireworks) {
                      if (keyboardSound) playSwordSound('sfinishOK.wav');
                      setShowFireworks(true);
                      setTimeout(() => setShowFireworks(false), 4000);
                    }
                  }}
                />
                <p style={{ color: 'green', padding: '10px', fontSize: '1.5em' }}>恭喜你！已完成本次学习。加油哦！</p>
                <p style={{ color: '#666', fontSize: '1.1em', marginTop: '10px' }}>按任意键继续学习</p>
                <p style={{ color: '#999', fontSize: '0.9em', marginTop: '5px' }}></p>
              </div>
            ) : filteredWords.length === 0 && progressStats.masteredProgress >= 100 ? (
              <p style={{ color: 'green', padding: '10px' }}>🎉 恭喜！{category} 级别所有单词已全部掌握！</p>
            ) : filteredWords.length === 0 ? (
              <p style={{ color: '#666', padding: '10px' }}>本轮学习已完成，开始进入下一轮</p>
              // <p style={{ color: '#666', padding: '10px' }}>本轮学习已完成，按任意键开始下一轮</p>
            ) : (
              <>
                <h3
                  ref={wordRef}
                  style={{
                    ...wordDisplayStyle,
                    visibility: wordSplitAnim ? 'hidden' : 'visible',
                  }}
                  className={uiState.isIncorrectWord ? 'word-incorrect' : ''}
                >
                  {uiState.isInMasterMode && uiState.masterModeWord === currentWord.word ? (
                    // 削词模式：根据输入逐个显示字母
                    <>
                      {currentWord.word.split('').map((letter, index) => {
                        const inputLower = inputValue.toLowerCase();
                        const isRevealed = index < inputLower.length;
                        return (
                          <span
                            key={index}
                            style={{
                              visibility: isRevealed ? 'visible' : 'hidden',
                              color: isRevealed ? currentTheme.text : 'transparent',
                            }}
                          >
                            {letter}
                          </span>
                        );
                      })}
                    </>
                  ) : (
                    // 正常模式：显示完整单词
                    currentWord.word || '无单词'
                  )}
                </h3>
                
                {/* 发音切换按钮 */}
                <div style={{ marginBottom: '10px' }}>
                  <button
                    onClick={() => {
                      if (audioRef.current) {
                        audioRef.current.pause();
                        audioRef.current.src = '';
                        audioRef.current = null;
                      }
                      setPronunciationType('us');
                    }}
                    style={{
                      padding: '5px 15px',
                      background: pronunciationType === 'us' ? '#1890ff' : '#f0f0f0',
                      color: pronunciationType === 'us' ? 'white' : '#666',
                      border: `1px solid ${theme === 'dark' ? '#555' : '#ddd'}`,
                      borderRadius: '4px 0 0 4px',
                      cursor: 'pointer',
                      fontSize: '0.9em',
                    }}
                  >
                    美式
                  </button>
                  <button
                    onClick={() => {
                      if (audioRef.current) {
                        audioRef.current.pause();
                        audioRef.current.src = '';
                        audioRef.current = null;
                      }
                      setPronunciationType('uk');
                    }}
                    style={{
                      padding: '5px 15px',
                      background: pronunciationType === 'uk' ? '#1890ff' : '#f0f0f0',
                      color: pronunciationType === 'uk' ? 'white' : '#666',
                      border: `1px solid ${theme === 'dark' ? '#555' : '#ddd'}`,
                      borderRadius: '0 4px 4px 0',
                      cursor: 'pointer',
                      fontSize: '0.9em',
                    }}
                  >
                    英式
                  </button>
                </div>

                <p style={{ fontSize: '1.2em', display: 'inline-flex', alignItems: 'center' }}>
                  音标: {currentWord.phonetic?.[pronunciationType] || '无'}
                  {currentWord.audio?.[pronunciationType] && currentWord.audio[pronunciationType] !== '' ? (
                    <>
                      <button
                        aria-label="播放发音"
                        onClick={() => playAudio(currentWord.audio[pronunciationType], currentWord.word, false)}
                        onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(2px)'}
                        onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        style={{
                          marginLeft: '20px',
                          position: 'relative',
                          top: '3px',
                          fontSize: '0.8em',
                          cursor: 'pointer',
                          padding: '2px',
                          lineHeight: '1',
                          background: 'none',
                          border: 'none',
                          display: 'inline-flex',
                          alignItems: 'center',
                          transition: 'transform 0.1s ease',
                        }}
                        title="单次播放"
                      >
                        🔊
                      </button>
                      <button
                        aria-label={loopPlay ? '停止循环播放' : '循环播放'}
                        onClick={toggleLoopPlay}
                        onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(2px)'}
                        onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        style={{
                          marginLeft: '5px',
                          position: 'relative',
                          top: '3px',
                          fontSize: '0.8em',
                          cursor: 'pointer',
                          padding: '2px',
                          lineHeight: '1',
                          color: loopPlay ? 'blue' : 'black',
                          background: 'none',
                          border: 'none',
                          display: 'inline-flex',
                          alignItems: 'center',
                          transition: 'transform 0.1s ease',
                        }}
                        title={loopPlay ? '停止循环' : '循环播放'}
                      >
                        {loopPlay ? '⏸️' : '🔁'}  {/* ✅ 修改：循环播放时显示暂停图标 */}
                      </button>
                    </>
                  ) : (
                    <span style={{ fontSize: '0.8em', color: 'red', marginLeft: '20px' }}>无发音</span>
                  )}
                </p>
                
                <p style={{ fontSize: '1.2em' }}>中文释义: {currentWord.meaning_cn || '无'}</p>
                {currentWord.example_en && (uiState.searchMode || (studyMode === 'usage' && showExampleAfterCorrect)) && (
                  <div 
                    onClick={() => {
                      if (uiState.searchMode) return;
                      toggleExamplePause();
                    }}
                    style={{
                      cursor: uiState.searchMode ? 'default' : 'pointer',
                    margin: '16px auto',
                    padding: '16px 20px',
                    background: theme === 'dark' ? 'rgba(255,255,255,0.05)' : '#f8f9fa',
                    border: theme === 'dark' ? '1px solid rgba(255,255,255,0.1)' : '1px solid #e8e8e8',
                    borderRadius: '12px',
                    textAlign: 'center',
                    width: '100%',
                    maxWidth: isMobile ? '300px' : '600px',
                    boxSizing: 'border-box',
                  }}>
                    <p style={{ 
                      fontSize: '1.05em', 
                      color: theme === 'dark' ? '#ddd' : '#444',
                      margin: '0 0 8px',
                      fontStyle: 'italic',
                      lineHeight: '1.6',
                    }}>
                      "{currentWord.example_en}"
                    </p>
                    <p style={{ 
                      fontSize: '0.9em', 
                      color: theme === 'dark' ? '#999' : '#999',
                      margin: '0 0 8px',
                    }}>
                      {currentWord.example_cn}
                    </p>
                    {studyMode === 'usage' && (
                      <div onClick={(e) => e.stopPropagation()} style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '4px', flexWrap: 'wrap' }}>
                        {isExamplePaused ? (
                          <>
                            <span style={{ fontSize: '0.8em', color: '#999', alignSelf: 'center' }}>⏸ 已暂停</span>
                            <button
                              onClick={() => replayExampleAudio(currentWord)}
                              style={{
                                padding: '4px 12px', fontSize: '0.8em', borderRadius: '16px',
                                border: '1px solid #1890ff', background: 'transparent',
                                color: '#1890ff', cursor: 'pointer',
                              }}
                            >
                              🔁 重播
                            </button>
                            <button
                              onClick={() => toggleExampleLoop(currentWord)}
                              style={{
                                padding: '4px 12px', fontSize: '0.8em', borderRadius: '16px',
                                border: '1px solid #1890ff',
                                background: isExampleLooping ? '#1890ff' : 'transparent',
                                color: isExampleLooping ? 'white' : '#1890ff',
                                cursor: 'pointer',
                              }}
                            >
                              🔂 循环
                            </button>
                            <button
                              onClick={toggleExamplePause}
                              style={{
                                padding: '4px 12px', fontSize: '0.8em', borderRadius: '16px',
                                border: '1px solid #52c41a', background: 'transparent',
                                color: '#52c41a', cursor: 'pointer',
                              }}
                            >
                              ▶ 继续
                            </button>
                          </>
                        ) : (
                          <span 
                            onClick={toggleExamplePause}
                            style={{ fontSize: '0.75em', color: '#bbb', cursor: 'pointer' }}
                          >
                            点击暂停
                          </span>
                        )}
                      </div>
                    )}
                    {uiState.searchMode && currentWord.example_audio_us && (
                      <div onClick={(e) => e.stopPropagation()} style={{ display: 'flex', justifyContent: 'center', gap: '8px', flexWrap: 'wrap' }}>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            // 停止所有正在播放的音频
                            if (searchExampleAudioRef.current) {
                              searchExampleAudioRef.current.pause();
                              searchExampleAudioRef.current.onended = null;
                              searchExampleAudioRef.current = null;
                            }
                            if (searchExampleAudioRef2.current) {
                              searchExampleAudioRef2.current.pause();
                              searchExampleAudioRef2.current = null;
                            }
                            if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; setLoopingAudio(null); setLoopAudioRef(null); }
                            setSearchExampleLoopType(null);
                            // 直接播放，不用延迟
                            const audio = new Audio(currentWord.example_audio_us);
                            audio.play().catch(err => console.log('播放失败:', err));
                            searchExampleAudioRef.current = audio;
                            console.log('美式音频已存入ref:', searchExampleAudioRef.current);
                          }}
                          style={{
                            padding: '4px 12px', fontSize: '0.85em', borderRadius: '16px',
                            border: '1px solid #1890ff', background: 'transparent',
                            color: '#1890ff', cursor: 'pointer',
                          }}
                        >
                          🔊 美式
                        </button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            if (searchExampleAudioRef.current) {
                              searchExampleAudioRef.current.pause();
                              searchExampleAudioRef.current.onended = null;
                              searchExampleAudioRef.current = null;
                            }
                            if (searchExampleAudioRef2.current) {
                              searchExampleAudioRef2.current.pause();
                              searchExampleAudioRef2.current = null;
                            }
                            if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; setLoopingAudio(null); setLoopAudioRef(null); }
                            setSearchExampleLoopType(null);
                            const audio = new Audio(currentWord.example_audio_uk);
                            audio.play().catch(err => console.log('播放失败:', err));
                            searchExampleAudioRef.current = audio;
                            console.log('美式音频已存入ref:', searchExampleAudioRef.current);
                          }}
                        >
                          🔁
                        </button>
                        <button
                          onClick={() => {
                            console.log('点击英式时ref状态:', searchExampleAudioRef.current);
                            if (searchExampleAudioRef.current) {
                              searchExampleAudioRef.current.pause();
                              searchExampleAudioRef.current.onended = null;
                              searchExampleAudioRef.current = null;
                            }
                            if (searchExampleAudioRef2.current) {
                              searchExampleAudioRef2.current.pause();
                              searchExampleAudioRef2.current = null;
                            }
                           if (loopAudioRef) { loopAudioRef.pause(); loopAudioRef.src = ''; setLoopingAudio(null); setLoopAudioRef(null); }
                            setSearchExampleLoopType(null);
                            const audio = new Audio(currentWord.example_audio_uk);
                            audio.play().catch(err => console.log('播放失败:', err));
                            searchExampleAudioRef.current = audio;
                          }}
                          style={{
                            padding: '4px 12px', fontSize: '0.85em', borderRadius: '16px',
                            border: '1px solid #1890ff', background: 'transparent',
                            color: '#1890ff', cursor: 'pointer',
                          }}
                        >
                          🔊 英式
                        </button>
                        <button
                          onClick={() => {
                            console.log('点击英式时ref状态:', searchExampleAudioRef.current);
                            const newType = searchExampleLoopType === 'uk' ? null : 'uk';
                            setSearchExampleLoopType(newType);
                            if (searchExampleAudioRef.current) {
                              searchExampleAudioRef.current.pause();
                              searchExampleAudioRef.current.onended = null;
                            }
                            if (newType === 'uk') {
                              const audio = new Audio(currentWord.example_audio_uk);
                              audio.onended = () => {
                                audio.currentTime = 0;
                                audio.play().catch(e => console.log('循环失败:', e));
                              };
                              audio.play().catch(err => console.log('播放失败:', err));
                              searchExampleAudioRef.current = audio;
                            }
                          }}
                          style={{
                            padding: '4px 10px', fontSize: '0.85em', borderRadius: '16px',
                            border: '1px solid #1890ff',
                            background: searchExampleLoopType === 'uk' ? '#1890ff' : 'transparent',
                            color: searchExampleLoopType === 'uk' ? 'white' : '#1890ff',
                            cursor: 'pointer',
                          }}
                        >
                          🔁
                        </button>
                      </div>
                    )}
                  </div>
                )}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    gap: '0px',
                    width: '100%',
                    maxWidth: isMobile ? '300px' : 'none',
                  }}>
                    <input
                      ref={inputRef}
                      type="text"
                      value={inputValue}
                      onChange={handleInputChange}
                      onBlur={handleInputBlur}
                      onFocus={() => {
                        updateUiState({ isWordInputFocused: true, isInputIncorrect: false });
                      }}
                      placeholder={showExampleAfterCorrect ? '📖 例句播放中...' : '开始输入'}
                      disabled={showExampleAfterCorrect}
                      className={uiState.isInputIncorrect ? 'input-incorrect' : ''}
                      style={{
                        ...inputFieldStyle,
                        opacity: showExampleAfterCorrect ? 0.6 : 1,
                        cursor: showExampleAfterCorrect ? 'not-allowed' : 'text',
                      }}
                    />
                    {uiState.showLoading && (
                      <div
                        style={{
                          width: '20px',
                          height: '20px',
                          border: '2px solid #ffffff',
                          borderBottom: '2px solid #3498db',
                          borderRadius: '50%',
                          animation: 'spin 1s linear infinite',
                          animationDirection: 'reverse',
                          flexShrink: 0,
                          position: 'relative',
                          left: '-12px',
                          top: '12px',
                        }}
                      />
                    )}
                  </div>
                  <div style={buttonContainerStyle}>
                    <label style={{ display: 'flex', alignItems: 'center', fontSize: '0.9em' }}>
                      <input
                        type="checkbox"
                        checked={autoPlay}
                        onChange={toggleAutoPlay}
                        style={{ marginRight: '5px' }}
                        disabled={words.length === 0 && error}
                      />
                      自动播放发音
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', fontSize: '0.9em' }}>
                      <input
                        type="checkbox"
                        checked={keyboardSound}
                        onChange={toggleKeyboardSound}
                        style={{ marginRight: '5px' }}
                        disabled={words.length === 0 && error}
                      />
                      开启音效
                    </label>
                  </div>

                  <div style={{ marginTop: '10px', fontSize: '0.9em', textAlign: 'center' }}>
                    {!user && (
                      <p style={{ margin: '5px 0', color: '#d9d9d9' }}>
                        如认识该词，登录可削掉，需时再释放。
                      </p>
                    )}
                    
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                      <button
                        onClick={() => handleManualMaster(currentWord.word)}
                        disabled={
                          !user || 
                          filteredWords.length === 0 || 
                          uiState.isMasterLoading || 
                          uiState.masterModeFailedWords[currentWord.word]
                        }
                        style={masterButtonStyle}
                        title={
                          uiState.masterModeFailedWords[currentWord.word]
                            ? '削词失败，请继续学习'
                            : uiState.isInMasterMode
                            ? '连续削词模式中，输入错误将退出'
                            : '点击进入削词模式'
                        }
                      >
                        {uiState.isMasterLoading ? (
                          <>
                            削词中
                            <div className="loading-spinner"></div>
                          </>
                        ) : uiState.isInMasterMode ? (
                          '连续削词中...'
                        ) : (
                          '进入削词模式（Ctrl + x）'
                        )}
                      </button>
                      
                      {uiState.isInMasterMode && (
                        <button
                          onClick={() => {
                            if (keyboardSound) playSwordSound('close02.wav');
                            updateUiState({
                              isInMasterMode: false,
                              masterModeWord: ''
                            });
                            setInputValue('');
                            if (inputRef.current) {
                              inputRef.current.focus();
                            }
                            console.log('手动退出削词模式');
                          }}
                          style={{
                            padding: isMobile ? '10px 15px' : '8px 20px',
                            background: '#ff4d4f',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            borderRadius: '4px',
                            fontSize: isMobile ? '0.9em' : '1em',
                            width: isMobile ? '100%' : 'auto',
                            maxWidth: isMobile ? '300px' : 'none'
                          }}
                        >
                          退出削词模式（Ctrl + c）
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                <ProgressBars
                  isMobile={isMobile}
                  bar1Label="学习进度"
                  bar1Current={progressStats.remainingWords}
                  bar1Total={progressStats.currentCycleTotalWords}
                  bar1Percent={progressStats.currentCycleProgress}
                  bar2Label="削词进度"
                  bar2Current={progressStats.totalMasteredForProgress}
                  bar2Total={progressStats.totalWords}
                  bar2Percent={progressStats.masteredProgress}
                />
              </>
            )
          )}
        </div>
      )}

      {/* 页脚 */}
      <footer style={footerStyle}>
        <div style={footerLinksStyle}>
          <button onClick={() => setCurrentPage('about')} style={{ background: 'none', border: 'none', color: '#1890ff', cursor: 'pointer', fontSize: '1em', padding: '5px' }}>关于我们</button>
          <button onClick={() => setCurrentPage('contact')} style={{ background: 'none', border: 'none', color: '#1890ff', cursor: 'pointer', fontSize: '1em', padding: '5px' }}>联系我们</button>
          <button onClick={() => setCurrentPage('faq')} style={{ background: 'none', border: 'none', color: '#1890ff', cursor: 'pointer', fontSize: '1em', padding: '5px' }}>常见问题</button>
          <button onClick={() => setCurrentPage('privacy')} style={{ background: 'none', border: 'none', color: '#1890ff', cursor: 'pointer', fontSize: '1em', padding: '5px' }}>隐私政策</button>
        </div>
        <p style={{ 
          margin: '10px 0', 
          color: '#999', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          flexWrap: 'wrap',
          gap: '5px'  // 添加统一间距
        }}>
          <span>© 2025 削词侠 XIAOCIXIA.CN All rights reserved.</span>
          <span>|</span>
          <a 
            href="https://beian.mps.gov.cn/#/query/webSearch?code=44196902000117"
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              color: '#999', 
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center'
            }}
          >
            <img 
              src="/images/filing-icon.png" 
              alt="公安备案图标" 
              style={{ 
                width: '16px', 
                height: '16px', 
                marginRight: '4px'
              }}
            />
            粤公网安备44196902000117号
          </a>
          <span>|</span>
          <a 
            href="https://beian.miit.gov.cn/" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: '#999', textDecoration: 'none' }}
          >
            粤ICP备20054820号
          </a>
        </p>
      </footer>
    </div>

    {/* 单词播放器弹窗 ← 新增这里 */}
      <WordPlayer
        isOpen={showWordPlayer}
        onClose={() => setShowWordPlayer(false)}
        words={words}
        filteredWords={filteredWords}
        category={category}
        categories={categories}
        theme={theme}
        sentenceSources={sentenceSources}
        defaultSentenceSource={currentSource}
        initialContentType="word"
      />

      {/* 微信绑定弹窗 */}
      {showWxBindModal && (
        <div
          onClick={() => setShowWxBindModal(false)}
          style={{
            position: 'fixed', inset: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: theme === 'dark' ? '#1f1f1f' : 'white',
              borderRadius: '16px', padding: '32px',
              width: isMobile ? '90vw' : '400px',
              boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
            }}
          >
            <h3 style={{ textAlign: 'center', marginBottom: '8px', color: theme === 'dark' ? '#fff' : '#333' }}>
              💬 微信扫码成功
            </h3>
            <p style={{ textAlign: 'center', color: '#999', fontSize: '0.9em', marginBottom: '24px' }}>
              请选择登录方式
            </p>

            {wxBindError && (
              <p style={{ color: '#ff4d4f', background: '#fff2f0', border: '1px solid #ffccc7', borderRadius: '6px', padding: '8px 12px', fontSize: '0.85em', marginBottom: '16px' }}>
                {wxBindError}
              </p>
            )}

            {/* 绑定已有邮箱账号 */}
            <div style={{ marginBottom: '20px' }}>
              <p style={{ fontWeight: '600', marginBottom: '12px', color: theme === 'dark' ? '#fff' : '#333' }}>
                绑定已有邮箱账号：
              </p>
              <input
                type="email"
                value={wxBindEmail}
                onChange={(e) => setWxBindEmail(e.target.value)}
                placeholder="电子邮件"
                style={{
                  width: '100%', padding: '10px 14px', marginBottom: '10px',
                  border: `1px solid ${theme === 'dark' ? '#444' : '#ddd'}`,
                  borderRadius: '8px', fontSize: '1em', outline: 'none',
                  background: theme === 'dark' ? '#2a2a2a' : '#fafafa',
                  color: theme === 'dark' ? '#fff' : '#333',
                  boxSizing: 'border-box',
                }}
              />
              <input
                type="password"
                value={wxBindPassword}
                onChange={(e) => setWxBindPassword(e.target.value)}
                placeholder="密码"
                style={{
                  width: '100%', padding: '10px 14px', marginBottom: '12px',
                  border: `1px solid ${theme === 'dark' ? '#444' : '#ddd'}`,
                  borderRadius: '8px', fontSize: '1em', outline: 'none',
                  background: theme === 'dark' ? '#2a2a2a' : '#fafafa',
                  color: theme === 'dark' ? '#fff' : '#333',
                  boxSizing: 'border-box',
                }}
              />
              <button
                onClick={async () => {
                  setWxBindError('');
                  try {
                    const res = await fetch(`${API_BASE_URL}/api/auth/wx-bind-email`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ tempToken: wxTempToken, email: wxBindEmail, password: wxBindPassword }),
                    });
                    const data = await res.json();
                    if (!res.ok) throw new Error(data.message);
                    setShowWxBindModal(false);
                    await handleWxLoginSuccess(data.token);
                  } catch(e) {
                    setWxBindError(e.message);
                  }
                }}
                style={{
                  width: '100%', padding: '11px',
                  background: '#1890ff', color: 'white',
                  border: 'none', borderRadius: '8px',
                  fontSize: '1em', fontWeight: '600', cursor: 'pointer',
                }}
              >
                绑定并登录
              </button>
            </div>

            <div style={{ textAlign: 'center', color: '#999', fontSize: '0.85em', margin: '16px 0' }}>
              — 或者 —
            </div>

            {/* 直接用微信注册新账号 */}
            <button
              onClick={async () => {
                setWxBindError('');
                try {
                  const res = await fetch(`${API_BASE_URL}/api/auth/wx-register`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ tempToken: wxTempToken }),
                  });
                  const data = await res.json();
                  if (!res.ok) throw new Error(data.message);
                  setShowWxBindModal(false);
                  await handleWxLoginSuccess(data.token);
                } catch(e) {
                  setWxBindError(e.message);
                }
              }}
              style={{
                width: '100%', padding: '11px',
                background: '#07C160', color: 'white',
                border: 'none', borderRadius: '8px',
                fontSize: '1em', fontWeight: '600', cursor: 'pointer',
              }}
            >
              💬 直接用微信注册新账号
            </button>

            <button
              onClick={() => setShowWxBindModal(false)}
              style={{
                width: '100%', padding: '11px', marginTop: '10px',
                background: 'none', color: '#999',
                border: `1px solid ${theme === 'dark' ? '#444' : '#ddd'}`,
                borderRadius: '8px', fontSize: '1em', cursor: 'pointer',
              }}
            >
              取消
            </button>
          </div>
        </div>
      )}

      {/* 登录弹窗（与学单词/学句子页面共用同一组件） */}
      <LoginModal
        showLoginModal={showLoginModal}
        setShowLoginModal={setShowLoginModal}
        theme={theme}
        isMobile={isMobile}
        isHovering={isHovering}
        loginTab={loginTab}
        setLoginTab={setLoginTab}
        authError={authError}
        setAuthError={setAuthError}
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        emailInputRef={emailInputRef}
        passwordInputRef={passwordInputRef}
        handleLoginFocus={handleLoginFocus}
        handleLogin={handleLogin}
        handleRegister={handleRegister}
        handleResetPassword={handleResetPassword}
        apiBase={API_BASE_URL}
      />


      {/* 小程序二维码悬浮按钮 */}
      <QRCodeFloatButton
        greenScreen={greenScreen}
        theme={theme}
        showQRCode={showQRCode}
        setShowQRCode={setShowQRCode}
      />
    </>
  );
}

export default App;